(function () {
  "use strict";

  var ROOT_SELECTOR = "[data-nf-floorfinder]";

  function initFloorFinder(root) {
    if (!root || root.dataset.ffsReady === "true") return;
    root.dataset.ffsReady = "true";

    var portal = root.querySelector("[data-ffs-portal]");
    var form = root.querySelector("[data-ffs-form]");
    if (!portal || !form) return;

    var screens = Array.prototype.slice.call(root.querySelectorAll("[data-ffs-screen]"));
    var questionScreens = screens.filter(function (screen) {
      return !screen.hasAttribute("data-result-screen") && !screen.hasAttribute("data-processing-screen");
    });
    var questionCount = Math.max(1, questionScreens.length);
    var entry = root.querySelector("[data-ffs-entry]");
    var entryStage = root.querySelector("[data-ffs-entry-stage]");
    var introVideo = root.querySelector("[data-ffs-intro-video]");
    var introEnter = root.querySelector("[data-ffs-entry-enter]");
    var introSkip = root.querySelector("[data-ffs-entry-skip]");
    var introLockup = root.querySelector("[data-ffs-intro-lockup]");
    var proofVideos = Array.prototype.slice.call(root.querySelectorAll("[data-ffs-proof-video]"));
    var proofCards = Array.prototype.slice.call(root.querySelectorAll("[data-ffs-proof-card]"));
    var proofObserver = null;
    var entryTimer = null;
    var introCtaTimer = null;
    var introClickReady = false;
    var introActive = false;
    var parallaxFrame = null;
    var parallaxTarget = { lockX: 0, lockY: 0, videoX: 0, videoY: 0 };
    var parallaxCurrent = { lockX: 0, lockY: 0, videoX: 0, videoY: 0 };
    var step = 0;
    var lastFocus = null;
    var closeTimer = null;
    var lightHolder = root.querySelector("[data-ffs-light-rooms]");
    var wetSpacesHolder = root.querySelector("[data-wet-spaces]");
    var progress = root.querySelector("[data-ffs-progress]");
    var progressTrack = root.querySelector("[data-ffs-progress-track]");
    var progressLabel = root.querySelector("[data-ffs-progress-label]");
    var contextKicker = root.querySelector("[data-ffs-context-kicker]");
    var contextTitle = root.querySelector("[data-ffs-context-title]");
    var contextNote = root.querySelector("[data-ffs-context-note]");
    var controls = root.querySelector("[data-ffs-controls]");
    var backButton = root.querySelector("[data-ffs-prev]");
    var nextButton = root.querySelector("[data-ffs-next]");
    var statusNode = root.querySelector("[data-ffs-status]");
    var liveNode = root.querySelector("[data-ffs-live]");
    var productCards = Array.prototype.slice.call(root.querySelectorAll("[data-ffs-product]"));
    var latestResult = null;
    var enterTimer = null;
    var lightroom = root.querySelector("[data-ffs-lightroom]");
    var lightCaption = root.querySelector("[data-ffs-light-caption]");
    var lookRail = root.querySelector("[data-look-rail]");
    var lookImage = root.querySelector("[data-look-image]");
    var lookShade = root.querySelector("[data-look-shade]");
    var lookPalette = root.querySelector("[data-look-palette]");
    var resultReveal = root.querySelector("[data-result-reveal]");
    var resultRevealImage = root.querySelector("[data-result-reveal-image]");
    var resultScreen = root.querySelector("[data-result-screen]");
    var processingScreen = root.querySelector("[data-processing-screen]");
    var leadGate = root.querySelector("[data-ffs-lead-gate]");
    var leadContent = root.querySelector("[data-ffs-lead-content]");
    var leadForm = root.querySelector(".nf-ffs__lead-form");
    var leadEmail = root.querySelector("[data-ffs-lead-email]");
    var leadName = root.querySelector("[data-ffs-lead-name]");
    var leadBrief = root.querySelector("[data-ffs-lead-brief]");
    var leadSubmit = root.querySelector("[data-ffs-lead-submit]");
    var leadStatus = root.querySelector("[data-ffs-lead-status]");
    var leadTeaser = root.querySelector("[data-ffs-lead-teaser]");
    var leadMessages = leadGate ? leadGate.dataset : {};
    var leadDeliveryEndpoint = leadGate ? leadGate.dataset.deliveryEndpoint || "" : "";
    var leadDeliveryKey = leadGate ? leadGate.dataset.deliveryKey || "" : "";
    var leadSubmitText = leadSubmit ? leadSubmit.querySelector("span") : null;
    var leadSubmitDefaultLabel = leadSubmitText ? leadSubmitText.textContent : "Email my brief";
    var nameInput = root.querySelector("[data-name-input]");
    var nameHelp = root.querySelector("[data-name-help]");
    var customerName = "";
    var colourTouched = false;
    var latestV3Brief = null;
    var thinkingStarted = false;
    var thinkingTimers = [];
    var thinkingTimer = null;
    var leadCaptured = false;
    var leadSubmitting = false;
    var leadViewTracked = false;
    var leadAnalyticsContext = {};
    var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var lightLabels = { low: "Low natural light", mid: "Balanced light", high: "Bright, sun-filled" };
    var chapterLabels = {
      name: "Personal studio",
      "category-interest": "Material universe",
      rooms: "Room plan",
      multi: "Style / life",
      palette: "Existing palette",
      "room-light": "Light map",
      single: "Priority",
      site: "Site reality",
      colour: "Colour direction",
      budget: "Investment"
    };

    var roomNames = {
      "open-living": "Living, kitchen and dining",
      "wet-area": "Bathroom or laundry",
      bedroom: "Bedrooms",
      hallway: "Entry or hallway",
      stairs: "Stairs",
      commercial: "Office, rental or commercial"
    };

    var categoryOrder = ["hybrid", "engineered", "laminate", "tiles", "carpet", "vinyl", "sheet-vinyl", "solid", "carpet-tile"];
    var categories = {
      hybrid: {
        label: "Hybrid flooring",
        url: "/collections/hybrid-flooring?view=nf-hybrid",
        summary: "A practical timber-look base for busy connected living areas.",
        caution: "Confirm the specific product warranty, wet-area limits and subfloor flatness before selection."
      },
      engineered: {
        label: "Engineered timber",
        url: "/collections/engineered?view=nf-timber",
        summary: "Real timber character with a more considered, premium material feel.",
        caution: "Real timber varies and can mark. Moisture, direct sun and installation method need product-specific advice."
      },
      laminate: {
        label: "Laminate",
        url: "/collections/laminate-flooring?view=nf-laminate",
        summary: "Strong visual value and a hard-wearing timber look for dry rooms.",
        caution: "Do not assume every laminate is waterproof. Confirm the product water rating and room suitability."
      },
      tiles: {
        label: "Tiles",
        url: "/collections/tiles?view=nf-tiles",
        summary: "The specialist direction for wet zones, entrances and architectural surfaces.",
        caution: "Confirm slip rating, indoor or outdoor use, substrate, waterproofing, grout and edge details."
      },
      carpet: {
        label: "Carpet",
        url: "/collections/carpet?view=nf-carpet",
        summary: "The softest and quietest direction for bedrooms and comfort-led zones.",
        caution: "Roll width, joins, stairs, underlay and installation should be measured and quoted."
      },
      vinyl: {
        label: "Vinyl plank",
        url: "/collections/vinyl-plank-1?view=nf-vinyl",
        summary: "A resilient plank direction for practical residential and commercial spaces.",
        caution: "Confirm glue-down, loose-lay or click format, wear class and subfloor preparation. Planks do not inherit sheet-vinyl wet-room capability."
      },
      "sheet-vinyl": {
        label: "Sheet vinyl",
        url: "/collections/vinyl-sheet?view=nf-sheet-vinyl",
        summary: "A continuous resilient surface for selected commercial, healthcare and expressly approved wet-area systems.",
        caution: "Require exact construction, roll width, use class, slip evidence and complete installation details; sheet format alone is not wet-area approval."
      },
      solid: {
        label: "Solid timber",
        url: "/collections/solid-timber?view=nf-solid-timber",
        summary: "Natural Australian timber character for a long-term premium project.",
        caution: "Allow for timber movement, site conditions, specialist installation and ongoing care."
      },
      "carpet-tile": {
        label: "Carpet tiles",
        url: "/collections/carpet-tile?view=nf-carpet-tile",
        summary: "A modular, replaceable option for offices, rentals and commercial rooms.",
        caution: "Confirm box coverage, adhesive, subfloor and the product's intended traffic classification."
      }
    };

    var styleLabels = {
      modern: "Modern Contemporary",
      classic: "Classic Timeless",
      japandi: "Japandi Calm",
      coastal: "Coastal / Hamptons",
      rustic: "Vintage Premium",
      industrial: "Industrial Loft",
      provincial: "French Provincial",
      midcentury: "Mid-Century Modern"
    };

    var paletteLabels = {
      wall_colour: {
        "crisp-white": "crisp white walls",
        "warm-white": "warm white walls",
        greige: "greige walls",
        "earthy-tone": "earthy-toned walls",
        "bold-dark": "bold dark walls",
        "not-sure": "walls still to confirm"
      },
      cabinet_colour: {
        white: "white cabinetry",
        "natural-timber": "natural timber cabinetry",
        grey: "grey cabinetry",
        "navy-green": "navy or green cabinetry",
        black: "black cabinetry",
        "not-sure": "cabinetry still to confirm"
      },
      bench_colour: {
        "white-stone": "white stone bench",
        "veined-stone": "veined stone bench",
        "grey-stone": "grey stone bench",
        timber: "timber bench",
        "dark-stone": "dark stone bench",
        "not-sure": "bench still to confirm"
      }
    };

    var swatchMap = {
      "crisp-white": "linear-gradient(135deg,#ffffff,#ece7dc)",
      "warm-white": "linear-gradient(135deg,#fff8e9,#eadfcb)",
      greige: "linear-gradient(135deg,#cfc3b4,#9f9182)",
      "earthy-tone": "linear-gradient(135deg,#b58f68,#75614d)",
      "bold-dark": "linear-gradient(135deg,#28313c,#111820)",
      white: "linear-gradient(135deg,#ffffff,#e8e3d8)",
      "natural-timber": "linear-gradient(135deg,#c39b6d,#805f3e)",
      grey: "linear-gradient(135deg,#b8b7b1,#6f716f)",
      "navy-green": "linear-gradient(135deg,#263d4d,#3b5b45)",
      black: "linear-gradient(135deg,#282624,#070707)",
      "white-stone": "linear-gradient(135deg,#ffffff,#e9e3da)",
      "veined-stone": "linear-gradient(135deg,#f4eee4 0%,#f4eee4 42%,#8b8076 45%,#f4eee4 49%,#d4c7b8 100%)",
      "grey-stone": "linear-gradient(135deg,#c8c5bf,#797b78)",
      timber: "linear-gradient(135deg,#bd9362,#775438)",
      "dark-stone": "linear-gradient(135deg,#47413b,#161412)",
      "not-sure": "repeating-linear-gradient(135deg,#f8f3ec 0 5px,#e6ded2 5px 10px)"
    };

    var glassLabels = { few: "a few windows", average: "average glazing", walls: "walls of glass" };
    var orientationLabels = { north: "north-facing light", east: "east-facing morning light", west: "west-facing afternoon light", south: "south-facing soft light", "not-sure": "light direction to confirm" };

    var palettes = {
      airy: {
        title: "Light, calm and quietly warm",
        name: "Airy calm",
        colours: [
          { label: "Blonde oak", value: "#cbb58f" },
          { label: "Warm ivory", value: "#e8dfcf" },
          { label: "Misted taupe", value: "#aaa092" }
        ]
      },
      warm: {
        title: "Natural warmth with gentle contrast",
        name: "Warm natural",
        colours: [
          { label: "Natural oak", value: "#a9865e" },
          { label: "Warm stone", value: "#c8b9a5" },
          { label: "Oatmeal textile", value: "#b7a789" }
        ]
      },
      architectural: {
        title: "Restrained, tonal and architectural",
        name: "Architectural neutral",
        colours: [
          { label: "Smoked oak", value: "#7d6753" },
          { label: "Soft limestone", value: "#bcb6aa" },
          { label: "Charcoal textile", value: "#625f5a" }
        ]
      },
      dark: {
        title: "Grounded depth with controlled contrast",
        name: "Dark and dramatic",
        colours: [
          { label: "Dark walnut", value: "#4c3e34" },
          { label: "Mid greige", value: "#a89b8d" },
          { label: "Warm wool", value: "#c3b39f" }
        ]
      },
      australian: {
        title: "Australian timber warmth, balanced with stone",
        name: "Australian character",
        colours: [
          { label: "Blackbutt", value: "#a56f42" },
          { label: "Sandstone", value: "#c9b595" },
          { label: "Gumleaf grey", value: "#8d9187" }
        ]
      }
    };

    function announce(message) {
      if (liveNode) liveNode.textContent = "";
      window.setTimeout(function () {
        if (liveNode) liveNode.textContent = message || "";
      }, 20);
    }

    function value(name) {
      var input = root.querySelector('[name="' + name + '"]:checked');
      return input ? input.value : "";
    }

    function values(name) {
      return Array.prototype.slice.call(root.querySelectorAll('[name="' + name + '"]:checked')).map(function (input) {
        return input.value;
      });
    }

    function unique(items) {
      return items.filter(function (item, index) {
        return item && items.indexOf(item) === index;
      });
    }

    function createElement(tag, className, text) {
      var element = document.createElement(tag);
      if (className) element.className = className;
      if (typeof text === "string") element.textContent = text;
      return element;
    }

    function createSymbol(name, modifier) {
      var icons = {
        "low-light": '<svg viewBox="0 0 40 40"><path d="M24.5 8.5a12.5 12.5 0 1 0 7 21.7 14 14 0 0 1-15.7-17.6 12.4 12.4 0 0 1 8.7-4.1Z"/><path d="M10 32h20"/></svg>',
        "balanced-light": '<svg viewBox="0 0 40 40"><path d="M20 8v5M20 27v5M8 20h5M27 20h5M11.5 11.5l3.4 3.4M25.1 25.1l3.4 3.4M28.5 11.5l-3.4 3.4M14.9 25.1l-3.4 3.4"/><path d="M20 14a6 6 0 0 1 0 12 6 6 0 0 1 0-12Z"/><path d="M20 14v12"/></svg>',
        "bright-light": '<svg viewBox="0 0 40 40"><path d="M20 6v6M20 28v6M6 20h6M28 20h6M10.1 10.1l4.2 4.2M25.7 25.7l4.2 4.2M29.9 10.1l-4.2 4.2M14.3 25.7l-4.2 4.2"/><circle cx="20" cy="20" r="7"/></svg>'
      };
      var symbol = createElement("span", "nf-ffs__symbol" + (modifier ? " " + modifier : ""));
      symbol.setAttribute("aria-hidden", "true");
      symbol.innerHTML = icons[name] || icons["balanced-light"];
      return symbol;
    }

    function sanitizeName(raw) {
      var cleaned = String(raw || "")
        .replace(/[^A-Za-z\s-]/g, "")
        .replace(/\s+/g, " ")
        .replace(/-+/g, "-")
        .trim()
        .slice(0, 20)
        .replace(/[\s-]+$/g, "");
      if (!cleaned) return "";
      return cleaned.split(/([ -])/).map(function (part) {
        if (!part || part === " " || part === "-") return part;
        return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
      }).join("");
    }

    function setNameHelp(message, isError) {
      if (!nameHelp) return;
      nameHelp.textContent = message || "Letters, spaces and hyphens only.";
      nameHelp.classList.toggle("is-error", Boolean(isError));
    }

    function commitName() {
      var sanitized = sanitizeName(nameInput ? nameInput.value : "");
      if (!sanitized) {
        setNameHelp("Enter your first name to continue.", true);
        return false;
      }
      customerName = sanitized;
      if (nameInput) nameInput.value = sanitized;
      setNameHelp("Thanks, " + customerName + ".", false);
      updateNameTemplates();
      return true;
    }

    function nameSuffix() {
      return customerName ? ", " + customerName : "";
    }

    function updateNameTemplates() {
      Array.prototype.slice.call(root.querySelectorAll("[data-name-heading]")).forEach(function (node) {
        var fallback = node.dataset.defaultHeading || node.textContent;
        var template = node.dataset.nameTemplate || fallback;
        node.textContent = customerName ? template.replace("{name}", customerName) : fallback;
      });
    }

    function questionNumber(screen) {
      var index = questionScreens.indexOf(screen);
      return index === -1 ? questionCount : index + 1;
    }

    function chapterLabel(screen) {
      if (!screen) return "Studio";
      if (screen.hasAttribute("data-result-screen")) return "Studio brief";
      if (screen.hasAttribute("data-processing-screen")) return "Studio thinking";
      if (screen.classList.contains("nf-ffs__screen--universe")) return "Material universe";
      return screen.dataset.contextKicker || chapterLabels[screen.dataset.required] || "Studio";
    }

    function selectedRooms() {
      return values("rooms");
    }

    function selectedCategoryInterests() {
      return values("category_interest");
    }

    function selectedStyles() {
      return values("styles");
    }

    function parseWeights(source) {
      var weights = {};
      String(source || "").split(",").forEach(function (entry) {
        var parts = entry.split(":");
        var key = (parts[0] || "").trim();
        var amount = Number(parts[1]);
        if (key && Number.isFinite(amount)) weights[key] = amount;
      });
      return weights;
    }

    function strongestWeight(weights, fallback) {
      return Object.keys(weights || {}).sort(function (a, b) { return weights[b] - weights[a]; })[0] || fallback;
    }

    function homeWorldProfile() {
      var input = root.querySelector('[name="home_world"]:checked');
      if (!input) return { value: "", label: "", style: {}, colour: {}, shade: {} };
      var label = input.closest(".nf-ffs__world");
      return {
        value: input.value,
        label: label ? label.querySelector("b").textContent.trim() : input.value,
        style: parseWeights(input.dataset.styleWeight),
        colour: parseWeights(input.dataset.colourWeight),
        shade: parseWeights(input.dataset.shadeWeight)
      };
    }

    function combinedStyleProfile() {
      var scores = {};
      var homeWorld = homeWorldProfile();
      Object.keys(homeWorld.style).forEach(function (key) { scores[key] = (scores[key] || 0) + homeWorld.style[key]; });
      selectedStyles().forEach(function (key) { scores[key] = (scores[key] || 0) + 4; });
      return Object.keys(scores).map(function (key) {
        return { key: key, label: styleLabels[key] || key, score: scores[key] };
      }).sort(function (a, b) { return b.score - a.score; });
    }

    function selectedStyleItems() {
      return Array.prototype.slice.call(root.querySelectorAll('[name="styles"]:checked')).map(function (input) {
        var tile = input.closest(".nf-ffs__style-tile");
        var image = tile ? tile.querySelector("img") : null;
        return {
          value: input.value,
          title: (tile && tile.dataset.styleTitle) || styleLabels[input.value] || input.value,
          descriptor: (tile && tile.dataset.styleDescriptor) || "",
          image: image ? (image.currentSrc || image.src) : ""
        };
      });
    }

    function labelFor(group, key) {
      return (paletteLabels[group] && paletteLabels[group][key]) || key || "to confirm";
    }

    function paletteSelections() {
      return [
        { key: "wall_colour", shortLabel: "Walls", value: value("wall_colour"), label: labelFor("wall_colour", value("wall_colour")), swatch: swatchMap[value("wall_colour")] || swatchMap["not-sure"] },
        { key: "cabinet_colour", shortLabel: "Cabinetry", value: value("cabinet_colour"), label: labelFor("cabinet_colour", value("cabinet_colour")), swatch: swatchMap[value("cabinet_colour")] || swatchMap["not-sure"] },
        { key: "bench_colour", shortLabel: "Bench", value: value("bench_colour"), label: labelFor("bench_colour", value("bench_colour")), swatch: swatchMap[value("bench_colour")] || swatchMap["not-sure"] }
      ];
    }

    function sentenceList(items) {
      items = items.filter(Boolean);
      if (items.length <= 1) return items[0] || "";
      if (items.length === 2) return items[0] + " and " + items[1];
      return items.slice(0, -1).join(", ") + " and " + items[items.length - 1];
    }

    function setRadio(name, targetValue) {
      var input = root.querySelector('[name="' + name + '"][value="' + targetValue + '"]');
      if (input) input.checked = true;
    }

    function suggestedColourDirection() {
      var styles = selectedStyles();
      var homeWorld = homeWorldProfile();
      var wall = value("wall_colour");
      var cabinet = value("cabinet_colour");
      var bench = value("bench_colour");
      var light = lightSummary();
      var shade = light.key === "low" ? "Light" : "In Between";
      var family = "Brown";
      var reasons = [];
      var hasStyle = function (key) { return styles.indexOf(key) !== -1; };

      if (homeWorld.value) {
        family = strongestWeight(homeWorld.colour, family);
        shade = strongestWeight(homeWorld.shade, shade);
        reasons.push(homeWorld.label + " home world");
      }

      if (hasStyle("industrial")) {
        family = "Gray";
        reasons.push("Industrial Loft style");
      } else if (hasStyle("provincial") || hasStyle("coastal")) {
        family = "Beige";
        reasons.push((hasStyle("provincial") ? "French Provincial" : "Coastal / Hamptons") + " style");
      } else if (hasStyle("rustic") || hasStyle("midcentury") || hasStyle("classic") || hasStyle("japandi")) {
        family = "Brown";
        reasons.push(styleLabels[styles[0]] + " style");
      } else if (hasStyle("modern")) {
        reasons.push("Modern Contemporary style");
      }

      if (hasStyle("coastal")) shade = "Light";
      if (hasStyle("japandi") && (wall === "crisp-white" || wall === "warm-white" || light.key === "high")) shade = "Light";
      if (wall === "greige" && hasStyle("japandi")) shade = "In Between";

      if (cabinet === "black" || cabinet === "navy-green" || wall === "bold-dark" || bench === "dark-stone") {
        shade = light.key === "low" ? "Light" : "In Between";
        if (family !== "Gray") family = "Brown";
        reasons.push("dark joinery contrast");
      }

      if ((wall === "crisp-white" || wall === "warm-white") && cabinet === "white" && (bench === "white-stone" || bench === "veined-stone")) {
        shade = "In Between";
        family = "Brown";
        reasons.push("all-white palette warmth");
      }

      if (wall && wall !== "not-sure") reasons.push(labelFor("wall_colour", wall));

      var shadeLabels = { Light: "Light", "In Between": "Mid-tone", Dark: "Dark" };
      var familyLabels = { Brown: "Warm timber", Beige: "Soft neutral", Gray: "Cool mineral", Australian: "Australian timber" };
      return {
        shade: shade,
        family: family,
        shadeLabel: shadeLabels[shade] || shade,
        familyLabel: familyLabels[family] || family,
        display: (shadeLabels[shade] || shade) + " / " + (familyLabels[family] || family),
        reason: sentenceList(unique(reasons)).replace("walls walls", "walls")
      };
    }

    function renderColourSuggestion() {
      var node = root.querySelector("[data-colour-suggestion]");
      if (!node) return;
      var suggestion = suggestedColourDirection();
      node.innerHTML = "";
      node.classList.add("is-visible");
      node.appendChild(document.createTextNode("Our read for you" + nameSuffix() + ": "));
      node.appendChild(createElement("b", "", suggestion.display));
      node.appendChild(document.createTextNode(" - drawn from " + (suggestion.reason || "your style, palette and light") + ". Change anything - you know your home best."));
    }

    function applySuggestedColour(force) {
      var suggestion = suggestedColourDirection();
      if (force || !colourTouched || !value("shade") || value("shade") === "auto") setRadio("shade", suggestion.shade);
      if (force || !colourTouched || !value("colour_family") || value("colour_family") === "auto") setRadio("colour_family", suggestion.family);
      renderColourSuggestion();
    }

    function dailyStressLabel() {
      var dailyLife = values("daily_life");
      if (dailyLife.indexOf("pets") !== -1) return "paws";
      if (dailyLife.indexOf("family") !== -1) return "little feet";
      if (dailyLife.indexOf("spills") !== -1) return "spills";
      if (dailyLife.indexOf("heavy-traffic") !== -1) return "heavy traffic";
      return "everyday living";
    }

    function candidateProfileCount(result, preference) {
      var topKeys = ((result && result.shortlist) || (result && result.top ? result.top.slice(0, 3) : [])).map(function (item) { return item.key; });
      return productCards.filter(function (card) {
        return topKeys.indexOf(card.dataset.category) !== -1 && productColourMatch(card, preference);
      }).length;
    }

    function showroomStockTotal(result, preference) {
      var topKeys = ((result && result.shortlist) || (result && result.top ? result.top.slice(0, 3) : [])).map(function (item) { return item.key; });
      return productCards.reduce(function (sum, card) {
        if (topKeys.indexOf(card.dataset.category) === -1 || !productColourMatch(card, preference)) return sum;
        var raw = String(card.dataset.stockSqm || "").replace(/[^0-9.]/g, "");
        var number = parseFloat(raw);
        return sum + (isFinite(number) ? number : 0);
      }, 0);
    }

    function clearThinkingTimers() {
      thinkingTimers.forEach(function (timer) { window.clearTimeout(timer); });
      thinkingTimers = [];
      if (thinkingTimer) window.clearTimeout(thinkingTimer);
      thinkingTimer = null;
    }

    function addThinkingTimer(callback, delay) {
      var timer = window.setTimeout(callback, delay);
      thinkingTimers.push(timer);
      return timer;
    }

    function animateCounter(node, target, duration) {
      if (!node) return;
      target = Math.max(0, Math.round(target || 0));
      if (reduceMotion || target === 0) {
        node.textContent = String(target);
        return;
      }
      var started = Date.now();
      function tick() {
        var progress = Math.min(1, (Date.now() - started) / duration);
        node.textContent = String(Math.round(target * progress));
        if (progress < 1) addThinkingTimer(tick, 45);
      }
      tick();
    }

    function renderThinkingIngredients(result, advice, profileCount, stockTotal) {
      var swatchHolder = root.querySelector("[data-thinking-swatches]");
      var styleHolder = root.querySelector("[data-thinking-styles]");
      var planHolder = root.querySelector("[data-thinking-plan]");
      var orientationNode = root.querySelector("[data-thinking-orientation]");
      var lightNode = root.querySelector("[data-thinking-light]");
      var roomsNode = root.querySelector("[data-thinking-rooms]");
      var stockNode = root.querySelector("[data-thinking-stock]");
      var profilesNode = root.querySelector("[data-thinking-profiles]");

      if (swatchHolder) {
        swatchHolder.innerHTML = "";
        paletteSelections().forEach(function (item, index) {
          var chip = createElement("span", "nf-ffs__thinking-swatch");
          chip.style.setProperty("--swatch", item.swatch);
          chip.style.setProperty("--delay", (index * 140) + "ms");
          chip.title = item.shortLabel + ": " + item.label;
          swatchHolder.appendChild(chip);
        });
      }

      if (styleHolder) {
        styleHolder.innerHTML = "";
        selectedStyleItems().forEach(function (item, index) {
          var tile = createElement("span", "nf-ffs__thinking-style");
          tile.style.setProperty("--rotate", (index === 0 ? -8 : 8) + "deg");
          tile.style.setProperty("--delay", (260 + index * 120) + "ms");
          if (item.image) {
            var img = document.createElement("img");
            img.src = item.image;
            img.alt = "";
            img.loading = "lazy";
            tile.appendChild(img);
          }
          styleHolder.appendChild(tile);
        });
      }

      if (planHolder) {
        planHolder.innerHTML = "";
        selectedRooms().forEach(function (room, index) {
          var zone = createElement("span", "nf-ffs__thinking-zone", roomNames[room] || room);
          zone.style.setProperty("--delay", (520 + index * 120) + "ms");
          planHolder.appendChild(zone);
        });
      }

      if (orientationNode) orientationNode.textContent = orientationLabels[value("orientation")] || advice.light.label;
      if (lightNode) {
        var rotations = { north: "18deg", east: "-4deg", west: "32deg", south: "-18deg", "not-sure": "8deg" };
        lightNode.style.setProperty("--arc-rotation", rotations[value("orientation")] || "8deg");
      }
      animateCounter(roomsNode, selectedRooms().length, 900);
      animateCounter(stockNode, stockTotal, 1300);
      animateCounter(profilesNode, profileCount, 1500);
    }

    function thinkingLines(result, advice, profileCount) {
      var orientation = orientationLabels[value("orientation")] || "natural light";
      var wall = labelFor("wall_colour", value("wall_colour")).replace(" walls", "");
      var oakCount = Math.max(1, selectedStyles().length);
      var scope = derivedProjectScope() === "whole-home" ? "whole-home" : derivedProjectScope() === "multi-room" ? "connected-room" : "single-room";
      return [
        "Reading your " + orientation + nameSuffix() + "...",
        "Balancing " + wall + " walls against " + oakCount + " oak tone" + (oakCount === 1 ? "" : "s") + "...",
        "Cross-checking " + profileCount + " colour profile" + (profileCount === 1 ? "" : "s") + " in store...",
        "Stress-testing for " + dailyStressLabel() + "...",
        "Drafting your " + scope + " plan" + (customerName ? " for " + customerName : "") + "..."
      ];
    }

    function startThinking() {
      if (thinkingStarted) return;
      thinkingStarted = true;
      clearThinkingTimers();
      var result = calculateScores();
      result.shortlist = recommendationShortlist(result);
      var advice = paletteAdvice();
      var profileCount = candidateProfileCount(result, advice.colour);
      var stockTotal = showroomStockTotal(result, advice.colour);
      var lineHolder = root.querySelector("[data-thinking-lines]");
      var progressBar = root.querySelector("[data-thinking-progress]");
      renderThinkingIngredients(result, advice, profileCount, stockTotal);
      if (lineHolder) lineHolder.innerHTML = "";
      if (progressBar) progressBar.style.width = reduceMotion ? "100%" : "";

      var lines = reduceMotion ? ["Preparing your plan" + (customerName ? " for " + customerName : "") + "..."] : thinkingLines(result, advice, profileCount);
      lines.forEach(function (line, index) {
        addThinkingTimer(function () {
          if (!lineHolder) return;
          var item = createElement("li");
          var span = createElement("span", "", line);
          item.appendChild(span);
          lineHolder.appendChild(item);
        }, reduceMotion ? 0 : index * 400);
      });

      thinkingTimer = window.setTimeout(function () {
        var resultIndex = screens.indexOf(resultScreen);
        if (resultIndex !== -1 && screens[step] === processingScreen) {
          step = resultIndex;
          render();
          focusScreenHeading(screens[step]);
        }
      }, reduceMotion ? 800 : 4500);
    }

    function derivedProjectScope() {
      var count = selectedRooms().length;
      if (count >= 4) return "whole-home";
      if (count >= 2) return "multi-room";
      return "single-room";
    }

    function currentRoomLights() {
      var result = {};
      if (!lightHolder) return result;
      Array.prototype.slice.call(lightHolder.querySelectorAll("[data-room-light]:checked")).forEach(function (input) {
        result[input.dataset.roomLight] = input.value;
      });
      return result;
    }

    function normalLight(key) {
      return key === "low" || key === "high" ? key : "mid";
    }

    function updateLookRail() {
      if (!lookRail) return;
      var suggestion = suggestedColourDirection();
      var shade = value("shade");
      if (!shade || shade === "auto") shade = suggestion.shade || "In Between";
      var family = value("colour_family") || suggestion.family || "Brown";
      var shadeLabels = { Light: "Light", "In Between": "Mid-tone", Dark: "Dark" };
      var familyLabels = { Brown: "Warm timber", Beige: "Soft neutral", Gray: "Cool mineral", Australian: "Australian timber" };
      var src = lookImage && (shade === "Light" ? lookImage.dataset.heroLight : shade === "Dark" ? lookImage.dataset.heroDark : lookImage.dataset.heroMid);
      if (lookImage && src && lookImage.src !== src) lookImage.src = src;
      lookRail.dataset.shade = shade.toLowerCase().replace(/\s+/g, "-");
      if (lookShade) lookShade.textContent = (shadeLabels[shade] || shade) + " " + ((familyLabels[family] || family || "timber") + "").toLowerCase() + " direction";
      if (lookPalette) {
        var palette = paletteSelections().filter(function (item) { return item.value && item.value !== "not-sure"; }).slice(0, 2).map(function (item) { return item.label; });
        var lightText = lightLabels[lookRail.dataset.light || "mid"] || "Balanced light";
        lookPalette.textContent = (palette.length ? "Pairs against " + palette.join(" and ") + ". " : "Choose walls and cabinetry to refine undertone. ") + lightText + ".";
      }
    }

    function setLightroom(key) {
      key = normalLight(key);
      if (lightroom) lightroom.dataset.light = key;
      if (lookRail) lookRail.dataset.light = key;
      if (lightCaption) lightCaption.setAttribute("aria-label", lightLabels[key]);
      updateLookRail();
    }

    function updateLightroom(room) {
      var lights = currentRoomLights();
      setLightroom((room && lights[room]) || lights[selectedRooms()[0]] || "mid");
    }

    function buildLightRows() {
      if (!lightHolder) return;
      var saved = currentRoomLights();
      var rooms = selectedRooms();
      lightHolder.innerHTML = "";

      rooms.forEach(function (room) {
        var row = createElement("div", "nf-ffs__light-row");
        var title = createElement("b", "", roomNames[room] || room);
        var options = createElement("div", "nf-ffs__light-options");
        options.setAttribute("role", "radiogroup");
        options.setAttribute("aria-label", "Natural light in " + (roomNames[room] || room));

        [
          { value: "low", label: "Low", icon: "low-light" },
          { value: "mid", label: "Balanced", icon: "balanced-light" },
          { value: "high", label: "Bright", icon: "bright-light" }
        ].forEach(function (option) {
          var label = document.createElement("label");
          var input = document.createElement("input");
          var span = createElement("span", "nf-ffs__light-text", option.label);
          input.type = "radio";
          input.name = "light_" + room;
          input.value = option.value;
          input.dataset.roomLight = room;
          if (saved[room] === option.value) input.checked = true;
          label.appendChild(input);
          label.appendChild(createSymbol(option.icon));
          label.appendChild(span);
          options.appendChild(label);
        });

        row.appendChild(title);
        row.appendChild(options);
        lightHolder.appendChild(row);
      });
      updateLightroom(rooms[0]);
    }

    function updateWetSpaces() {
      if (!wetSpacesHolder) return;
      var hasWetArea = selectedRooms().indexOf("wet-area") !== -1;
      wetSpacesHolder.hidden = !hasWetArea;
      if (!hasWetArea) {
        Array.prototype.slice.call(wetSpacesHolder.querySelectorAll("input")).forEach(function (input) { input.checked = false; });
      }
    }

    function setSelectionClasses() {
      Array.prototype.slice.call(root.querySelectorAll("label")).forEach(function (label) {
        var input = label.querySelector("input[type='radio'], input[type='checkbox']");
        if (input) label.classList.toggle("is-selected", input.checked);
      });
    }

    function isScreenValid(screen) {
      if (!screen || screen.hasAttribute("data-result-screen") || screen.hasAttribute("data-processing-screen")) return true;
      var requirement = screen.dataset.required || "";
      if (requirement === "name") return Boolean(sanitizeName(nameInput ? nameInput.value : ""));
      if (requirement === "category-interest") return selectedCategoryInterests().length > 0;
      if (requirement === "rooms") {
        var rooms = selectedRooms();
        return rooms.length > 0 && (rooms.indexOf("wet-area") === -1 || values("wet_spaces").length > 0);
      }
      if (requirement === "single") return Boolean(screen.querySelector("input:checked"));
      if (requirement === "multi") return Boolean(screen.querySelector("input:checked"));
      if (requirement === "palette") return Boolean(value("wall_colour") && value("cabinet_colour") && value("bench_colour"));
      if (requirement === "room-light") {
        var rooms = selectedRooms();
        var lights = currentRoomLights();
        return rooms.length > 0 && rooms.every(function (room) { return Boolean(lights[room]); }) && Boolean(value("glass_amount") && value("orientation"));
      }
      if (requirement === "site") return Boolean(value("subfloor"));
      if (requirement === "colour") return Boolean(value("shade") && value("colour_family"));
      if (requirement === "budget") return Boolean(value("budget"));
      return true;
    }

    function validationMessage(screen) {
      if (!screen) return "Choose an option to continue.";
      if (screen.dataset.required === "name") return "Enter your first name to continue.";
      if (screen.dataset.required === "category-interest") return "Choose at least one material direction, or choose guide me.";
      if (screen.dataset.required === "rooms") return selectedRooms().indexOf("wet-area") !== -1 && !values("wet_spaces").length ? "Choose the bathroom, toilet or laundry spaces included." : "Choose at least one space to design.";
      if (screen.dataset.required === "palette") return "Choose a wall, cabinetry and bench colour, or choose not sure.";
      if (screen.dataset.required === "room-light") return "Choose room light, glass amount and orientation.";
      if (screen.dataset.required === "site") return "Choose the subfloor that is closest to your home.";
      if (screen.dataset.required === "colour") return "Choose a shade depth and colour family.";
      if (screen.dataset.required === "budget") return "Choose an investment level.";
      if (screen.dataset.max) return "Choose at least one, up to " + screen.dataset.max + ".";
      return "Choose at least one option to continue.";
    }

    function updateControls() {
      var active = screens[step];
      var valid = isScreenValid(active);
      var onResult = active && active.hasAttribute("data-result-screen");
      var onProcessing = active && active.hasAttribute("data-processing-screen");
      var onWelcome = active && active.dataset.required === "name";
      var isLastQuestion = questionScreens.indexOf(active) === questionCount - 1;
      if (backButton) backButton.disabled = step === 0 || onProcessing;
      if (nextButton) {
        nextButton.disabled = !valid || onResult || onProcessing || onWelcome;
        nextButton.innerHTML = isLastQuestion
          ? 'Build my floor plan <svg aria-hidden="true" viewBox="0 0 24 24"><path d="m9 18 6-6-6-6"/></svg>'
          : 'Continue <svg aria-hidden="true" viewBox="0 0 24 24"><path d="m9 18 6-6-6-6"/></svg>';
      }
      if (statusNode) statusNode.textContent = valid ? "" : validationMessage(active);
    }

    function updateContext(screen) {
      if (!screen) return;
      if (contextKicker) contextKicker.textContent = screen.dataset.contextKicker || "FloorFinder Studio";
      if (contextTitle) contextTitle.textContent = screen.dataset.contextTitle || "Your floor direction";
      if (contextNote) contextNote.textContent = screen.dataset.contextNote || "Build a clear showroom brief.";
    }

    function focusScreenHeading(screen) {
      if (!screen) return;
      var heading = screen.querySelector("h1, h2");
      if (!heading) return;
      heading.setAttribute("tabindex", "-1");
      window.setTimeout(function () {
        heading.focus({ preventScroll: true });
      }, 220);
    }

    function render() {
      if (enterTimer) window.clearTimeout(enterTimer);
      var activeScreen = screens[step];
      screens.forEach(function (screen, index) {
        screen.classList.toggle("is-active", index === step);
        screen.classList.toggle("is-before", index < step);
        screen.classList.remove("is-entered");
        screen.setAttribute("aria-hidden", index === step ? "false" : "true");
      });
      enterTimer = window.setTimeout(function () {
        if (screens[step]) screens[step].classList.add("is-entered");
      }, 30);

      var onResult = activeScreen && activeScreen.hasAttribute("data-result-screen");
      var onProcessing = activeScreen && activeScreen.hasAttribute("data-processing-screen");
      var onWelcome = activeScreen && activeScreen.dataset.required === "name";
      portal.classList.toggle("is-result", Boolean(onResult));
      portal.classList.toggle("is-processing", Boolean(onProcessing));
      portal.classList.toggle("is-welcome", Boolean(onWelcome));
      if (controls) controls.setAttribute("aria-hidden", onResult || onProcessing || onWelcome ? "true" : "false");

      var qNumber = questionNumber(activeScreen);
      var progressValue = onResult || onProcessing ? 100 : (qNumber / questionCount) * 100;
      if (progress) progress.style.width = progressValue + "%";
      if (progressTrack) {
        progressTrack.setAttribute("aria-valuemax", String(questionCount));
        progressTrack.setAttribute("aria-valuenow", String(Math.min(questionCount, qNumber)));
      }
      if (progressLabel) progressLabel.textContent = chapterLabel(activeScreen);

      updateNameTemplates();
      updateContext(activeScreen);
      if (activeScreen && activeScreen.dataset.required === "colour") applySuggestedColour(false);
      updateLookRail();
      updateControls();
      setSelectionClasses();
      if (activeScreen) activeScreen.scrollTop = 0;

      if (onProcessing) startThinking();
      if (onResult) {
        renderResults();
      } else {
        pauseProofVideos(false);
      }
    }

    function addScore(scores, reasons, key, amount, reason) {
      if (!categories[key]) return;
      scores[key] += amount;
      if (reason) reasons[key].push(reason);
    }

    function calculateScores() {
      var scores = {};
      var reasons = {};
      categoryOrder.forEach(function (key) {
        scores[key] = 0;
        reasons[key] = [];
      });

      var rooms = selectedRooms();
      var dailyLife = values("daily_life");
      var priority = value("priority");
      var complexity = values("complexity");
      var budget = value("budget");
      var subfloor = value("subfloor");
      var categoryInterest = selectedCategoryInterests();

      if (categoryInterest.indexOf("hybrid") !== -1) {
        addScore(scores, reasons, "hybrid", 5, "You asked the Studio to compare hybrid flooring first.");
      }
      if (categoryInterest.indexOf("engineered") !== -1) {
        addScore(scores, reasons, "engineered", 4, "You asked the Studio to compare real timber character.");
        addScore(scores, reasons, "solid", 3, "Solid timber stays visible as a premium natural-material comparison.");
      }
      if (categoryInterest.indexOf("laminate") !== -1) {
        addScore(scores, reasons, "laminate", 5, "You asked the Studio to compare laminate as a transformation option.");
      }
      if (categoryInterest.indexOf("carpet") !== -1) {
        addScore(scores, reasons, "carpet", 5, "You asked the Studio to compare softness and bedroom comfort.");
        addScore(scores, reasons, "carpet-tile", 2, "Carpet tiles stay visible where modular practicality matters.");
      }
      if (categoryInterest.indexOf("tiles-vinyl") !== -1) {
        addScore(scores, reasons, "tiles", 4, "You asked the Studio to compare wet-zone and architectural surfaces.");
        addScore(scores, reasons, "vinyl", 4, "Vinyl plank stays visible as a resilient practical surface comparison.");
        addScore(scores, reasons, "sheet-vinyl", 3, "Sheet vinyl stays visible for projects that benefit from a continuous resilient surface.");
      }

      rooms.forEach(function (room) {
        if (room === "open-living") {
          addScore(scores, reasons, "hybrid", 7, "It creates a practical continuous base across living, kitchen and dining.");
          addScore(scores, reasons, "engineered", 4, "It gives the connected living zone real timber character.");
          addScore(scores, reasons, "laminate", 3, "It offers strong visual value where the selected range suits the kitchen brief.");
          addScore(scores, reasons, "vinyl", 4, "It is a practical direction for a frequently cleaned connected zone.");
          addScore(scores, reasons, "tiles", 3, "It is worth comparing for the hardest-working kitchen area.");
          addScore(scores, reasons, "solid", 2, "It suits a long-term natural-material project when kitchen conditions are planned carefully.");
        }
        if (room === "wet-area") {
          addScore(scores, reasons, "tiles", 10, "It is the first specialist direction for the bathroom or laundry in your plan.");
          addScore(scores, reasons, "sheet-vinyl", 5, "Only expressly approved sheet-vinyl wet-area systems are worth a technical discussion.");
        }
        if (room === "bedroom") {
          addScore(scores, reasons, "carpet", 8, "It brings softness, warmth and acoustic comfort to your bedrooms.");
          addScore(scores, reasons, "engineered", 3, "It keeps real timber character running into the bedroom.");
          addScore(scores, reasons, "hybrid", 3, "It can continue an easy-care hard floor into the bedroom.");
          addScore(scores, reasons, "laminate", 3, "It is a value-conscious hard-floor option for a dry bedroom.");
        }
        if (room === "hallway") {
          addScore(scores, reasons, "hybrid", 6, "It suits the concentrated traffic in your entry or hallway.");
          addScore(scores, reasons, "laminate", 5, "It gives the hallway a hard-wearing timber look.");
          addScore(scores, reasons, "vinyl", 5, "It is a resilient direction for a frequently cleaned entry.");
          addScore(scores, reasons, "tiles", 4, "It is worth comparing for wet shoes and hard entry traffic.");
        }
        if (room === "stairs") {
          addScore(scores, reasons, "carpet", 6, "It is a comfort and grip-led direction for stairs.");
          addScore(scores, reasons, "engineered", 4, "It can create a premium timber stair statement with specialist detailing.");
          addScore(scores, reasons, "solid", 4, "It supports a natural timber stair direction with specialist installation.");
          addScore(scores, reasons, "hybrid", 2, "It may coordinate with adjoining hybrid floors when stair components are confirmed.");
        }
        if (room === "commercial") {
          addScore(scores, reasons, "carpet-tile", 8, "It is a modular direction for office, rental or commercial use.");
          addScore(scores, reasons, "vinyl", 8, "Vinyl plank is a resilient direction for rolling traffic and frequent cleaning.");
          addScore(scores, reasons, "sheet-vinyl", 8, "Sheet vinyl is a resilient direction for continuous commercial surfaces and disciplined cleaning.");
          addScore(scores, reasons, "tiles", 5, "It is worth comparing for high traffic and easy surface care.");
          addScore(scores, reasons, "laminate", 3, "A suitable commercial-rated laminate may be worth comparing.");
          addScore(scores, reasons, "carpet", 3, "It can soften sound in a residential home office when rolling-chair use is limited.");
        }
      });

      if (dailyLife.indexOf("family") !== -1) {
        addScore(scores, reasons, "hybrid", 5, "It aligns with the spills and active wear of a young family.");
        addScore(scores, reasons, "vinyl", 4, "It aligns with easy everyday cleaning for a young family.");
        addScore(scores, reasons, "laminate", 3, "It is worth comparing where scratch resistance and value matter.");
        addScore(scores, reasons, "tiles", 3, "It is worth comparing in the hardest-working family zones.");
      }
      if (dailyLife.indexOf("pets") !== -1) {
        addScore(scores, reasons, "hybrid", 6, "It is a strong comparison for claws, fur and everyday pet mess.");
        addScore(scores, reasons, "vinyl", 5, "It is an easy-care comparison for a pet household.");
        addScore(scores, reasons, "laminate", 3, "It may suit pet traffic where its scratch and water ratings are confirmed.");
        addScore(scores, reasons, "tiles", 4, "It is a durable comparison for pet traffic in practical zones.");
        scores.engineered -= 1;
        scores.solid -= 2;
      }
      if (dailyLife.indexOf("spills") !== -1) {
        addScore(scores, reasons, "hybrid", 5, "It addresses your regular-spill concern.");
        addScore(scores, reasons, "vinyl", 5, "It addresses your regular cleaning and spill concern.");
        addScore(scores, reasons, "tiles", 4, "It is a robust comparison where spills are frequent.");
        scores.carpet -= 2;
        scores.solid -= 1;
      }
      if (dailyLife.indexOf("heavy-traffic") !== -1) {
        addScore(scores, reasons, "hybrid", 5, "It supports concentrated foot traffic and frequent chair movement.");
        addScore(scores, reasons, "laminate", 5, "It is worth comparing for visible-wear resistance and value.");
        addScore(scores, reasons, "tiles", 5, "It is a strong hard-surface comparison for heavy traffic.");
        addScore(scores, reasons, "carpet-tile", 6, "It supports office use and local replacement around rolling chairs.");
        addScore(scores, reasons, "vinyl", 4, "It is worth comparing for rolling-chair use with the correct specification.");
      }

      if (priority === "easy") {
        addScore(scores, reasons, "hybrid", 5, "It aligns with your easy-clean priority.");
        addScore(scores, reasons, "vinyl", 5, "It aligns with your easy-clean priority.");
        addScore(scores, reasons, "tiles", 4, "It aligns with your easy surface-care priority.");
        addScore(scores, reasons, "laminate", 4, "It offers simple routine care and visible-wear resistance in suitable dry rooms.");
      }
      if (priority === "soft") {
        addScore(scores, reasons, "carpet", 9, "It is the clearest answer to your warm, soft underfoot priority.");
        addScore(scores, reasons, "carpet-tile", 5, "It can soften sound in office and commercial zones.");
        addScore(scores, reasons, "vinyl", 2, "Some systems may soften the hard-floor feel when correctly specified.");
      }
      if (priority === "natural") {
        addScore(scores, reasons, "engineered", 9, "It directly answers your preference for genuine timber character.");
        addScore(scores, reasons, "solid", 10, "It is the purest natural-timber direction in the range.");
      }
      if (priority === "value") {
        addScore(scores, reasons, "laminate", 8, "It is a strong visual-value direction.");
        addScore(scores, reasons, "vinyl", 6, "It offers a practical value comparison.");
        addScore(scores, reasons, "hybrid", 4, "It balances performance and timber-look value.");
        addScore(scores, reasons, "carpet-tile", 3, "Local replacement can support practical value in suitable rooms.");
      }

      if (subfloor === "concrete") {
        addScore(scores, reasons, "hybrid", 2, "It is commonly considered over prepared concrete slabs.");
        addScore(scores, reasons, "vinyl", 2, "It is commonly considered over carefully prepared concrete slabs.");
        addScore(scores, reasons, "tiles", 2, "It is a familiar direction over a suitable prepared slab.");
      }
      if (subfloor === "timber") {
        addScore(scores, reasons, "hybrid", 2, "It may suit a correctly prepared timber or sheet subfloor.");
        addScore(scores, reasons, "laminate", 2, "It may suit a correctly prepared timber or sheet subfloor.");
        addScore(scores, reasons, "carpet", 2, "It is familiar over a correctly prepared timber or sheet subfloor.");
      }
      if (complexity.indexOf("occupied") !== -1) {
        addScore(scores, reasons, "hybrid", 2, "Its installation pathway may be worth comparing for a staged, occupied project.");
        addScore(scores, reasons, "laminate", 2, "Its installation pathway may be worth comparing for a staged, occupied project.");
      }

      if (budget === "value") {
        addScore(scores, reasons, "laminate", 7, "It sits naturally in a value-led product comparison.");
        addScore(scores, reasons, "vinyl", 6, "It sits naturally in a value-led product comparison.");
        addScore(scores, reasons, "hybrid", 3, "It is worth comparing where performance justifies the step up.");
      }
      if (budget === "balanced") {
        addScore(scores, reasons, "hybrid", 6, "It fits your balance of appearance, performance and spend.");
        addScore(scores, reasons, "laminate", 3, "It gives the balanced shortlist a value benchmark.");
        addScore(scores, reasons, "vinyl", 3, "It gives the balanced shortlist a practical benchmark.");
        addScore(scores, reasons, "carpet", 3, "It supports comfort where that investment is most visible.");
      }
      if (budget === "premium") {
        addScore(scores, reasons, "engineered", 8, "It fits your preference for a more premium material finish.");
        addScore(scores, reasons, "solid", 8, "It fits your preference for a premium natural material.");
        addScore(scores, reasons, "tiles", 2, "Premium format and finish can strengthen architectural wet zones.");
        addScore(scores, reasons, "carpet", 2, "Premium fibre and construction can strengthen comfort-led rooms.");
      }

      var onlyWetAreas = rooms.length > 0 && rooms.every(function (room) { return room === "wet-area"; });
      var onlyBedrooms = rooms.length > 0 && rooms.every(function (room) { return room === "bedroom"; });
      if (onlyWetAreas) {
        categoryOrder.forEach(function (key) {
          if (key === "tiles") return;
          scores[key] = -1000;
          reasons[key] = [categories[key].label + " is not offered for a bathroom, toilet or laundry recommendation."];
        });
        addScore(scores, reasons, "tiles", 20, "Tiles are the Studio's specialist recommendation for bathrooms, toilets and laundries.");
      }
      if (onlyBedrooms) {
        scores.tiles = -1000;
        reasons.tiles = ["Tiles are not offered as the Studio's bedroom-floor recommendation."];
      }

      var top = categoryOrder.map(function (key, index) {
        return { key: key, score: scores[key], order: index, data: categories[key], reasons: unique(reasons[key]) };
      }).sort(function (a, b) {
        if (b.score !== a.score) return b.score - a.score;
        return a.order - b.order;
      });

      return { top: top, scores: scores, reasons: reasons };
    }

    function lightSummary() {
      var lights = currentRoomLights();
      var keys = Object.keys(lights);
      if (!keys.length) return { key: "mid", label: "Balanced overall light", detail: "Your light reads as balanced overall." };
      var total = keys.reduce(function (sum, key) {
        return sum + (lights[key] === "low" ? 1 : lights[key] === "high" ? 3 : 2);
      }, 0);
      var nudge = 0;
      var glass = value("glass_amount");
      var orientation = value("orientation");
      if (glass === "few") nudge -= 0.18;
      if (glass === "walls") nudge += 0.22;
      if (orientation === "north") nudge += 0.24;
      if (orientation === "east" || orientation === "west") nudge += 0.08;
      if (orientation === "south") nudge -= 0.24;
      var average = Math.max(1, Math.min(3, (total / keys.length) + nudge));
      var detailExtra = " " + (glassLabels[glass] || "") + (orientation ? ", " + (orientationLabels[orientation] || "") : "") + ".";
      if (average < 1.67) return { key: "low", label: "Mostly low natural light", detail: "Keep the main floor light to mid-tone and warm enough to avoid a flat, cold read." + detailExtra };
      if (average > 2.33) return { key: "high", label: "Mostly bright natural light", detail: "Your brighter rooms can carry deeper flooring without losing as much visual openness." + detailExtra };
      return { key: "mid", label: "Mixed or balanced light", detail: "A light-mid or natural tone gives the most consistent bridge between brighter and softer rooms." + detailExtra };
    }

    function colourPreference() {
      var suggestion = suggestedColourDirection();
      var selectedShade = value("shade") || "auto";
      var selectedFamily = value("colour_family") || "auto";
      var effectiveShade = selectedShade === "auto" ? suggestion.shade : selectedShade;
      var effectiveFamily = selectedFamily === "auto" ? suggestion.family : selectedFamily;

      var shadeLabels = { Light: "Light", "In Between": "Mid-tone", Dark: "Dark" };
      var familyLabels = { Brown: "Warm timber", Beige: "Soft neutral", Gray: "Cool mineral", Australian: "Australian timber" };
      return {
        selectedShade: selectedShade,
        selectedFamily: selectedFamily,
        shade: effectiveShade,
        family: effectiveFamily,
        shadeLabel: shadeLabels[effectiveShade] || effectiveShade,
        familyLabel: familyLabels[effectiveFamily] || effectiveFamily,
        display: (shadeLabels[effectiveShade] || effectiveShade) + " / " + (familyLabels[effectiveFamily] || effectiveFamily),
        guided: selectedShade === "auto" || selectedFamily === "auto",
        suggestion: suggestion
      };
    }

    function paletteAdvice() {
      var light = lightSummary();
      var finishes = values("finishes");
      var dailyLife = values("daily_life");
      var colour = colourPreference();
      var paletteKey = colour.family === "Australian" ? "australian" : colour.shade === "Dark" ? "dark" : colour.family === "Gray" ? "architectural" : colour.shade === "Light" || colour.family === "Beige" ? "airy" : "warm";
      var palette = palettes[paletteKey] || palettes.warm;
      var paletteItems = paletteSelections();
      var surfaces = sentenceList([
        paletteItems[0].value !== "not-sure" ? paletteItems[0].label : "",
        paletteItems[2].value !== "not-sure" ? paletteItems[2].label : ""
      ]);
      var styleItem = combinedStyleProfile()[0];
      var styleMood = styleItem ? styleItem.label.split(" / ")[0].replace(" Calm", "").replace(" Contemporary", "").replace(" Timeless", "").replace(" Premium", "") : "";
      var floorRead = (colour.shadeLabel + " " + colour.familyLabel).toLowerCase();
      var opening = surfaces
        ? "Against your " + surfaces + ", a " + floorRead + " floor keeps the " + (styleMood || "whole-home") + " direction calm without going flat."
        : "A " + floorRead + " floor gives the " + (styleMood || "whole-home") + " direction warmth without flattening the scheme.";
      var notes = [opening, light.detail];

      if (colour.shade === "Dark" && light.key === "low") {
        notes[1] = "You prefer a dark floor, but several rooms read low-light. Compare the dark option beside a mid-tone full board before carrying it through the largest connected area.";
      } else if (colour.shade === "Dark" && light.key === "high") {
        notes[1] = "Your stronger natural light gives a deeper floor room to feel grounded rather than closed-in. Keep walls and large furniture quieter so the floor remains intentional.";
      }
      if (finishes.indexOf("timber") !== -1) notes.push("With existing timber, match the undertone rather than trying to copy the grain exactly.");
      if (finishes.indexOf("black") !== -1) notes.push("Dark joinery already supplies contrast, so a mid-tone floor will usually keep the scheme balanced.");
      if (finishes.indexOf("stone") !== -1) notes.push("Use a warm-neutral bridge between stone surfaces and timber tones to stop the palette feeling disconnected.");
      if (dailyLife.indexOf("pets") !== -1) notes.push("A varied mid-tone often disguises fur, dust and small everyday marks better than a very dark, uniform surface.");
      notes.push("Treat the online colour as a shortlist: compare full boards vertically and flat in your actual daylight before ordering.");

      return { palette: palette, note: notes.join(" "), light: light, colour: colour };
    }

    function roomRecommendation(room) {
      var priority = value("priority");
      var dailyLife = values("daily_life");
      var budget = value("budget");
      var key = "hybrid";
      var note = "Confirm the final product and installation details in a showroom.";

      if (room === "wet-area") {
        key = "tiles";
        note = "Tiles only. Confirm slip rating, waterproofing, substrate and grout before selection.";
      } else if (room === "bedroom") {
        if (priority === "soft") key = "carpet";
        else if (priority === "natural" || budget === "premium") key = "engineered";
        else if (priority === "value" || budget === "value") key = "laminate";
        else key = "hybrid";
        note = key === "carpet" ? "Compare fibre, pile, underlay and how joins will be placed." : "Keep the undertone connected to adjoining rooms.";
      } else if (room === "stairs") {
        if (priority === "soft" || dailyLife.indexOf("family") !== -1) key = "carpet";
        else if (priority === "natural" || budget === "premium") key = "engineered";
        else key = "hybrid";
        note = "Stair nosing, edge detail, grip and installation need a specialist check.";
      } else if (room === "commercial") {
        key = priority === "soft" ? "carpet-tile" : "vinyl";
        note = "Confirm the product's commercial rating, installation and replacement plan.";
      } else if (room === "hallway") {
        if (dailyLife.indexOf("spills") !== -1) key = "tiles";
        else if (budget === "value") key = "laminate";
        else key = "hybrid";
        note = "Compare visible wear, wet-shoe traffic and transitions into adjoining rooms.";
      } else if (room === "open-living") {
        if ((priority === "natural" || budget === "premium") && dailyLife.indexOf("spills") === -1 && dailyLife.indexOf("pets") === -1) key = "engineered";
        else if ((priority === "value" || budget === "value") && dailyLife.indexOf("spills") === -1) key = "laminate";
        else key = "hybrid";
        note = "Use full boards to judge colour, grain repeat and scale across the larger connected area.";
      }

      return { key: key, data: categories[key], note: note };
    }

    function roomPlanData() {
      var plan = [];
      selectedRooms().forEach(function (room) {
        var recommendation = roomRecommendation(room);
        var labels = room === "wet-area" && values("wet_spaces").length
          ? values("wet_spaces").map(function (space) { return space.charAt(0).toUpperCase() + space.slice(1); })
          : [roomNames[room] || room];
        labels.forEach(function (label) {
          plan.push({ room: label, category: recommendation.data.label, note: recommendation.note });
        });
      });
      return plan;
    }

    function renderPalette(advice) {
      var title = root.querySelector("[data-palette-title]");
      var note = root.querySelector("[data-palette-note]");
      var swatches = root.querySelector("[data-palette-swatches]");
      if (title) title.textContent = advice.palette.title;
      if (note) note.textContent = advice.note;
      if (!swatches) return;
      swatches.innerHTML = "";
      advice.palette.colours.forEach(function (colour) {
        var item = createElement("span", "nf-ffs__swatch");
        var chip = createElement("i");
        var label = createElement("span", "", colour.label);
        chip.style.setProperty("--swatch", colour.value);
        item.appendChild(chip);
        item.appendChild(label);
        swatches.appendChild(item);
      });
    }

    function recommendationShortlist(result) {
      var preferredKeys = [];
      var rooms = selectedRooms();
      var onlyWetAreas = rooms.length > 0 && rooms.every(function (room) { return room === "wet-area"; });
      var onlyBedrooms = rooms.length > 0 && rooms.every(function (room) { return room === "bedroom"; });
      if (onlyWetAreas) {
        return result.top.filter(function (item) { return item.key === "tiles"; }).slice(0, 1);
      }
      if (result.top[0] && !(onlyBedrooms && result.top[0].key === "tiles")) preferredKeys.push(result.top[0].key);
      selectedRooms().forEach(function (room) {
        preferredKeys.push(roomRecommendation(room).key);
      });
      result.top.forEach(function (item) {
        if (onlyBedrooms && item.key === "tiles") return;
        preferredKeys.push(item.key);
      });
      return unique(preferredKeys).slice(0, 3).map(function (key) {
        return result.top.filter(function (item) { return item.key === key; })[0];
      }).filter(Boolean);
    }

    function renderCategories(result) {
      var holder = root.querySelector("[data-category-results]");
      if (!holder) return;
      holder.innerHTML = "";
      var fitLabels = ["Strong first fit", "Best comparison", "Specialist alternative"];
      (result.shortlist || result.top.slice(0, 3)).forEach(function (item, index) {
        var card = createElement("article", "nf-ffs__category-card");
        var fit = createElement("span", "", fitLabels[index]);
        var title = createElement("h4", "", item.data.label);
        var reason = createElement("p", "", item.reasons.slice(0, 2).join(" ") || item.data.summary);
        var caution = createElement("small", "", "Check in store: " + item.data.caution);
        var link = createElement("a");
        var arrow = createElement("span", "nf-ffs__link-arrow");
        arrow.setAttribute("aria-hidden", "true");
        link.href = item.data.url;
        link.appendChild(createElement("span", "", "Explore " + item.data.label));
        link.appendChild(arrow);
        card.appendChild(fit);
        card.appendChild(title);
        card.appendChild(reason);
        card.appendChild(caution);
        card.appendChild(link);
        holder.appendChild(card);
      });
    }

    function renderRoomPlan() {
      var holder = root.querySelector("[data-room-plan]");
      if (!holder) return;
      holder.innerHTML = "";
      var lights = currentRoomLights();
      var lightLabels = { low: "Low light", mid: "Balanced light", high: "Bright light" };
      selectedRooms().forEach(function (room) {
        var recommendation = roomRecommendation(room);
        var roomLabels = room === "wet-area" && values("wet_spaces").length
          ? values("wet_spaces").map(function (space) { return space.charAt(0).toUpperCase() + space.slice(1); })
          : [roomNames[room] || room];
        roomLabels.forEach(function (roomLabel) {
          var card = createElement("article", "nf-ffs__room-card");
          card.appendChild(createElement("span", "", lightLabels[lights[room]] || "Light to confirm"));
          card.appendChild(createElement("h4", "", roomLabel + ": " + recommendation.data.label));
          card.appendChild(createElement("p", "", recommendation.note));
          holder.appendChild(card);
        });
      });
    }

    function productColourMatch(card, preference) {
      if (!card || card.dataset.colourMapped !== "true") return false;
      var shade = (card.dataset.shade || "").toLowerCase();
      var colour = (card.dataset.colour || "").toLowerCase();
      var search = (card.dataset.search || "").toLowerCase();
      var shadeMatch = shade === preference.shade.toLowerCase();
      var familyMatch = false;

      if (preference.family === "Brown") familyMatch = colour === "brown";
      if (preference.family === "Beige") familyMatch = ["beige", "cream", "light"].indexOf(colour) !== -1;
      if (preference.family === "Gray") familyMatch = colour === "gray" || colour === "grey";
      if (preference.family === "Australian") {
        familyMatch = colour === "brown" && ["blackbutt", "spotted gum", "tallowwood", "gum"].some(function (term) {
          return search.indexOf(term) !== -1;
        });
      }

      return shadeMatch && familyMatch;
    }

    function filteredCollectionUrl(url, preference) {
      var target = new URL(url, window.location.origin);
      target.searchParams.set("filter.p.m.custom.browse_by_shade_new", preference.shade);
      target.searchParams.set("filter.p.m.custom.browse_by_color_new", preference.family === "Australian" ? "Brown" : preference.family);
      return target.pathname + target.search + target.hash;
    }

    function renderProducts(result, advice) {
      var preference = advice.colour;
      var selected = [];
      var topKeys = (result.shortlist || result.top.slice(0, 3)).map(function (item) { return item.key; });
      var empty = root.querySelector("[data-product-empty]");
      productCards.forEach(function (card) {
        card.hidden = true;
        card.classList.remove("is-primary");
      });

      topKeys.forEach(function (key, index) {
        var matches = productCards.filter(function (card) {
          return card.dataset.category === key && productColourMatch(card, preference);
        });
        var allowance = index === 0 ? 2 : 1;
        selected = selected.concat(matches.slice(0, allowance));
      });

      if (selected.length < 3) {
        productCards.forEach(function (card) {
          if (selected.length >= 3) return;
          if (selected.indexOf(card) !== -1 || topKeys.indexOf(card.dataset.category) === -1) return;
          if (productColourMatch(card, preference)) selected.push(card);
        });
      }

      selected.slice(0, 3).forEach(function (card, index) {
        card.hidden = false;
        card.classList.toggle("is-primary", index === 0);
        var fit = card.querySelector("[data-product-fit]");
        var tone = card.querySelector("[data-product-tone]");
        var sameCategory = card.dataset.category === topKeys[0];
        var fitLabel = sameCategory && index === 0 ? "Best material + colour fit" : sameCategory ? "Same category, compare texture" : "Colour-matched alternative";
        if (fit) fit.textContent = fitLabel + " - " + categories[card.dataset.category].label;
        if (tone) tone.textContent = preference.shadeLabel + " / " + preference.familyLabel;
        var imageHolder = card.querySelector("[data-product-image]");
        if (imageHolder && !imageHolder.querySelector("img") && card.dataset.image) {
          var image = document.createElement("img");
          image.src = card.dataset.image;
          image.alt = card.dataset.title || "Recommended flooring product";
          image.loading = "lazy";
          image.decoding = "async";
          imageHolder.appendChild(image);
        }
      });

      if (empty) {
        var primaryMatches = selected.filter(function (card) { return card.dataset.category === topKeys[0]; }).length;
        empty.hidden = selected.length >= 3 && primaryMatches > 0;
        if (!selected.length) {
          empty.textContent = "Your material direction is ready, but we cannot confidently confirm an exact online colour match in this range yet. Compare the full colour board in a showroom.";
        } else if (!primaryMatches) {
          empty.textContent = "We cannot confidently confirm the exact colour in the leading material category online yet. The options below are colour-matched alternatives, not substitutes for that material choice.";
        } else if (selected.length < 3) {
          empty.textContent = "Only products with a confirmed shade and colour-family match are shown. Compare the wider colour board in a showroom.";
        }
      }

      return selected.slice(0, 3);
    }

    function briefData(result, advice, matchedProducts) {
      var lights = currentRoomLights();
      var light = advice.light;
      return {
        version: 3,
        updatedAt: new Date().toISOString(),
        projectScope: derivedProjectScope(),
        homeWorld: homeWorldProfile(),
        rooms: selectedRooms(),
        wetSpaces: values("wet_spaces"),
        roomLighting: lights,
        dailyLife: values("daily_life"),
        priority: value("priority"),
        categoryInterest: selectedCategoryInterests(),
        subfloor: value("subfloor"),
        complexity: values("complexity"),
        finishes: values("finishes"),
        budget: value("budget"),
        palette: advice.palette,
        selectedShade: value("shade"),
        selectedColourFamily: value("colour_family"),
        colourDirection: advice.colour.display,
        effectiveShade: advice.colour.shade,
        effectiveColourFamily: advice.colour.family,
        designerNote: advice.note,
        roomPlan: roomPlanData(),
        overallLight: light.key,
        overallLightLabel: light.label,
        overallLightDetail: light.detail,
        pets: values("daily_life").indexOf("pets") !== -1,
        categories: (result.shortlist || result.top.slice(0, 3)).map(function (item) {
          return { label: item.data.label, url: item.data.url, score: item.score };
        }),
        products: (matchedProducts || []).map(function (card) {
          var link = card.querySelector("[data-ffs-product-link]");
          return { title: card.dataset.title, category: categories[card.dataset.category].label, url: link ? link.href : "" };
        })
      };
    }

    function briefDataV4(v3, result, advice, matchedProducts) {
      var data = {};
      Object.keys(v3).forEach(function (key) { data[key] = v3[key]; });
      var profileCount = candidateProfileCount(result, advice.colour);
      data.version = 4;
      data.firstName = customerName;
      data.nameSkipped = !customerName;
      data.styles = selectedStyleItems().map(function (item) {
        return { value: item.value, title: item.title, descriptor: item.descriptor };
      });
      data.styleProfile = combinedStyleProfile();
      data.homeWorld = homeWorldProfile();
      data.wetSpaces = values("wet_spaces");
      data.categoryInterest = selectedCategoryInterests();
      data.paletteInputs = paletteSelections().map(function (item) {
        return { key: item.key, label: item.shortLabel, value: item.value, display: item.label };
      });
      data.wall_colour = value("wall_colour");
      data.cabinet_colour = value("cabinet_colour");
      data.bench_colour = value("bench_colour");
      data.glass_amount = value("glass_amount");
      data.orientation = value("orientation");
      data.long_hallway = value("long_hallway") || "no";
      data.colourSuggestion = advice.colour.suggestion || suggestedColourDirection();
      data.processing = {
        candidateProfiles: profileCount,
        showroomStockSqm: showroomStockTotal(result, advice.colour)
      };
      data.compatibilityKey = "nfFloorFinderBriefV3";
      data.products = (matchedProducts || []).map(function (card) {
        var link = card.querySelector("[data-ffs-product-link]");
        return { title: card.dataset.title, category: categories[card.dataset.category].label, url: link ? link.href : "" };
      });
      return data;
    }

    function saveBrief(v3, v4) {
      try {
        window.localStorage.setItem("nfFloorFinderBriefV3", JSON.stringify(v3));
        window.localStorage.setItem("nfFloorFinderBriefV2", JSON.stringify(v3));
        window.localStorage.setItem("nfFloorFinderBrief", JSON.stringify(v3));
        if (v4) window.localStorage.setItem("nfFloorFinderBriefV4", JSON.stringify(v4));
      } catch (error) {
        return false;
      }
      return true;
    }

    function updateResultReveal(advice) {
      if (!resultReveal || !resultRevealImage || !advice) return;
      var shade = advice.colour.shade;
      var src = shade === "Light" ? resultRevealImage.dataset.heroLight : shade === "Dark" ? resultRevealImage.dataset.heroDark : resultRevealImage.dataset.heroMid;
      if (src) resultRevealImage.src = src;
      resultReveal.dataset.light = normalLight(advice.light.key);
    }

    function renderRunnerCard() {
      var card = root.querySelector("[data-runner-card]");
      if (!card) return;
      var show = value("long_hallway") === "yes";
      card.hidden = !show;
      var heading = card.querySelector("[data-runner-heading]");
      if (heading) heading.textContent = customerName ? "That long hallway is asking for a runner, " + customerName + "." : "That long hallway is asking for a runner.";
    }

    function renderResults() {
      var result = calculateScores();
      result.shortlist = recommendationShortlist(result);
      var advice = paletteAdvice();
      updateResultReveal(advice);
      var rooms = selectedRooms();
      var heading = root.querySelector("[data-result-heading]");
      var copy = root.querySelector("[data-result-copy]");
      var chips = root.querySelector("[data-result-chips]");
      var collectionLink = root.querySelector("[data-result-collection]");
      var scopeLabels = { "whole-home": "Whole-home plan", "multi-room": "Connected-room plan", "single-room": "Single-room plan" };
      var budgetLabels = { value: "Value led", balanced: "Balanced investment", premium: "Premium material", open: "Trade-offs open" };
      var primaryResult = result.shortlist[0];
      var secondaryResult = result.shortlist[1];

      if (heading) heading.textContent = customerName ? customerName + ", here's your floor." : "Here's your floor.";
      if (copy && primaryResult) {
        copy.textContent = advice.colour.display + " is the colour direction, led by " + primaryResult.data.label.toLowerCase() + ". " + (secondaryResult ? secondaryResult.data.label + " is the useful comparison; specialist rooms stay separate below." : "For a bathroom, toilet or laundry, the Studio keeps the recommendation to tiles only.");
      }
      if (chips) {
        chips.innerHTML = "";
        [
          scopeLabels[derivedProjectScope()] || "Flooring plan",
          rooms.length + (rooms.length === 1 ? " room" : " rooms"),
          advice.light.label,
          advice.colour.display,
          combinedStyleProfile().slice(0, 2).map(function (item) { return item.label; }).join(" + ") || "Style selected",
          budgetLabels[value("budget")] || "Budget to compare"
        ].forEach(function (label) { chips.appendChild(createElement("span", "", label)); });
      }
      if (collectionLink && primaryResult) {
        collectionLink.href = filteredCollectionUrl(primaryResult.data.url, advice.colour);
        collectionLink.textContent = "Explore " + primaryResult.data.label;
      }

      renderPalette(advice);
      renderCategories(result);
      renderRoomPlan();
      var matchedProducts = renderProducts(result, advice);
      renderRunnerCard();
      latestV3Brief = briefData(result, advice, matchedProducts);
      latestResult = briefDataV4(latestV3Brief, result, advice, matchedProducts);
      leadAnalyticsContext = {
        category: primaryResult ? primaryResult.key : "unknown",
        match_count: matchedProducts.length,
        project_scope: derivedProjectScope()
      };
      renderLeadTeaser(primaryResult, matchedProducts.length);
      saveBrief(latestV3Brief, latestResult);
      prepareLeadForm();
      setLeadState(leadCaptured);
      document.dispatchEvent(new CustomEvent("nf:floorfinder:complete", { detail: latestResult }));
      announce(leadCaptured ? (leadMessages.messageSuccess || "Your FloorFinder brief is on its way.") : (leadMessages.messageReady || "Your complete FloorFinder result is ready above."));
    }

    function renderLeadTeaser(primaryResult, matchCount) {
      if (!leadTeaser) return;
      var template = matchCount > 0
        ? (leadMessages.messageTeaser || "We found {count} colour-matched products, led by {category}.")
        : (leadMessages.messageTeaserEmpty || "Your material direction and room-by-room plan are ready.");
      var category = primaryResult && primaryResult.data ? primaryResult.data.label : "your recommended material";
      leadTeaser.textContent = template
        .replace("{count}", String(matchCount))
        .replace("{category}", category.toLowerCase());
    }

    function leadAttributionText() {
      var params = new URLSearchParams(window.location.search);
      var keys = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "gclid", "fbclid"];
      function safeAttribution(value, maxLength) {
        return String(value || "").replace(/[\r\n\t]+/g, " ").trim().slice(0, maxLength);
      }
      var campaign = keys.map(function (key) {
        var campaignValue = safeAttribution(params.get(key), 200);
        return campaignValue ? key + ": " + campaignValue : "";
      }).filter(Boolean);
      var sourceLines = [
        "Page: " + safeAttribution(window.location.href.split("#")[0], 500),
        "Referrer: " + safeAttribution(document.referrer || "Direct / unavailable", 500)
      ];
      if (campaign.length) sourceLines.push("Campaign: " + campaign.join(" | "));
      sourceLines.push("Captured: " + new Date().toISOString());
      return sourceLines.join("\n");
    }

    function trackLead(stage) {
      var detail = {
        stage: stage,
        category: leadAnalyticsContext.category || "unknown",
        match_count: leadAnalyticsContext.match_count || 0,
        project_scope: leadAnalyticsContext.project_scope || "unknown"
      };
      document.dispatchEvent(new CustomEvent("nf:floorfinder:lead-" + stage, { detail: detail }));
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({
          event: "nf_floorfinder_lead",
          floorfinder_lead_stage: detail.stage,
          floorfinder_category: detail.category,
          floorfinder_match_count: detail.match_count,
          floorfinder_project_scope: detail.project_scope
        });
      }
    }

    function prepareLeadForm() {
      if (leadName) leadName.value = customerName || "FloorFinder customer";
      if (leadBrief) {
        leadBrief.value = "FLOORFINDER STUDIO LEAD\n\n" + briefText(latestResult) + "\n\nATTRIBUTION\n" + leadAttributionText();
      }
    }

    function setLeadState(sent) {
      leadCaptured = Boolean(sent);
      if (leadContent) leadContent.hidden = false;
      if (leadGate) {
        leadGate.hidden = false;
        leadGate.classList.toggle("is-complete", leadCaptured);
      }
      if (leadForm) leadForm.classList.toggle("is-complete", leadCaptured);
      if (leadEmail) leadEmail.disabled = leadCaptured;
      if (leadSubmit) leadSubmit.disabled = leadCaptured;
      if (leadSubmitText) leadSubmitText.textContent = leadCaptured ? "Brief sent" : leadSubmitDefaultLabel;
      if (latestResult) activateProofVideos();
      else pauseProofVideos(false);
      if (!leadViewTracked && latestResult) {
        leadViewTracked = true;
        trackLead("view");
      }
    }

    function setLeadStatus(message, isError) {
      if (!leadStatus) return;
      leadStatus.textContent = message || "";
      leadStatus.classList.toggle("is-error", Boolean(isError));
    }
    function customerBriefPayload() {
      var categoryNames = latestResult && Array.isArray(latestResult.categories)
        ? latestResult.categories.map(function (item) { return item.label; }).filter(Boolean)
        : [];
      var roomValues = latestResult && Array.isArray(latestResult.rooms) ? latestResult.rooms : [];
      var fullBrief = briefText(latestResult);
      return {
        first_name: customerName || "FloorFinder customer",
        last_name: "Studio brief",
        email: leadEmail ? leadEmail.value.trim() : "",
        phone: "",
        street_address: "",
        suburb: "",
        postcode: "",
        rooms: roomValues.map(function (room) { return roomNames[room] || room; }).join(", ") || "Not supplied",
        existing_flooring: "Not supplied",
        removal_needed: "Not supplied",
        new_flooring: categoryNames.join(", ") || "FloorFinder recommendation",
        preferred_day: "Not selected",
        preferred_time: "Not selected",
        notes: "AUTOMATIC CUSTOMER BRIEF REQUESTED - 30 SECOND DELIVERY TARGET\n\n" + fullBrief,
        branch: "FloorFinder Studio",
        branch_id: "floorfinder",
        referral_code: "",
        source: "floorfinder_studio",
        send_customer_brief: true,
        delivery_target_seconds: 30,
        brief_subject: "Your National Floors FloorFinder brief",
        brief_text: fullBrief,
        requested_at: new Date().toISOString()
      };
    }

    function submitCustomerBrief() {
      if (!leadDeliveryEndpoint || !leadDeliveryKey) {
        return Promise.reject(new Error("FloorFinder delivery endpoint is not configured"));
      }
      var controller = typeof AbortController === "function" ? new AbortController() : null;
      var timeout = window.setTimeout(function () { if (controller) controller.abort(); }, 15000);
      return fetch(leadDeliveryEndpoint, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          apikey: leadDeliveryKey,
          Authorization: "Bearer " + leadDeliveryKey,
          "x-client-info": "national-floors-floorfinder/1.0"
        },
        body: JSON.stringify(customerBriefPayload()),
        signal: controller ? controller.signal : undefined
      }).then(function (response) {
        return response.text().then(function (body) {
          if (!response.ok) throw new Error("Customer brief delivery failed");
          if (body) {
            try {
              var parsed = JSON.parse(body);
              if (parsed && parsed.error) throw new Error("Customer brief delivery was rejected");
            } catch (error) {
              if (error && error.message === "Customer brief delivery was rejected") throw error;
            }
          }
        });
      }).finally(function () { window.clearTimeout(timeout); });
    }

    function submitLead(event) {
      event.preventDefault();
      if (!leadForm || leadSubmitting) return;
      if (!leadEmail || !leadEmail.checkValidity()) {
        if (leadEmail) leadEmail.focus();
        setLeadStatus(leadMessages.messageInvalid || "Enter a valid email address so we can send your brief.", true);
        return;
      }

      prepareLeadForm();
      leadSubmitting = true;
      if (leadSubmit) leadSubmit.disabled = true;
      leadForm.setAttribute("aria-busy", "true");
      setLeadStatus(leadMessages.messageSaving || "Preparing and sending your brief...", false);
      trackLead("submit");

      var saveForTeam = fetch(leadForm.action, {
        method: "POST",
        body: new FormData(leadForm),
        headers: { Accept: "text/html" }
      }).then(function (response) {
        if (!response.ok) throw new Error("Lead submission failed");
        return response.text().then(function (html) {
          var succeeded = response.url.indexOf("contact_posted=true") !== -1 || html.indexOf("contact_posted=true") !== -1;
          var returnedErrors = /class=["'][^"']*errors[^"']*["']/.test(html);
          if (returnedErrors && !succeeded) throw new Error("Lead submission rejected");
        });
      });

      Promise.all([saveForTeam, submitCustomerBrief()]).then(function () {
        leadCaptured = true;
        setLeadState(true);
        setLeadStatus(leadMessages.messageSuccess || "Sent. Your personalised FloorFinder brief should arrive within 30 seconds.", false);
        document.dispatchEvent(new CustomEvent("nf:floorfinder:lead", {
          detail: { captured: true, deliveryTargetSeconds: 30 }
        }));
        trackLead("success");
        announce(leadMessages.messageSuccess || "Your FloorFinder brief is on its way and should arrive within 30 seconds.");
        if (leadStatus) {
          leadStatus.setAttribute("tabindex", "-1");
          leadStatus.focus({ preventScroll: true });
        }
      }).catch(function () {
        trackLead("error");
        setLeadStatus(leadMessages.messageError || "We couldn't send the brief. Please check your email and try again.", true);
      }).finally(function () {
        leadSubmitting = false;
        if (leadSubmit) leadSubmit.disabled = leadCaptured;
        leadForm.removeAttribute("aria-busy");
      });
    }

    function briefText(data) {
      if (!data) return "";
      var lines = [
        "NATIONAL FLOORS - FLOORFINDER SHOWROOM BRIEF",
        "",
        data.firstName ? "Customer: " + data.firstName : "Customer: Name not supplied",
        "Project: " + (data.projectScope || "Not specified"),
        "Rooms: " + data.roomPlan.map(function (item) { return item.room; }).join(", "),
        data.homeWorld && data.homeWorld.label ? "Home world: " + data.homeWorld.label : "Home world: Not specified",
        data.styles && data.styles.length ? "Style: " + data.styles.map(function (item) { return item.title; }).join(" + ") : "Style: Not specified",
        data.categoryInterest && data.categoryInterest.length ? "Material interest: " + data.categoryInterest.join(", ") : "Material interest: Guide me",
        data.paletteInputs ? "Palette: " + data.paletteInputs.map(function (item) { return item.display; }).join("; ") : "Palette: Not specified",
        "Glass/orientation: " + (glassLabels[data.glass_amount] || "not specified") + ", " + (orientationLabels[data.orientation] || "not specified"),
        "Long hallway: " + (data.long_hallway === "yes" ? "Yes" : "No"),
        "Overall light: " + data.overallLightLabel,
        "Colour direction: " + data.colourDirection,
        "Product investment: " + data.budget,
        "",
        "START BY COMPARING",
        data.categories.map(function (item, index) { return (index + 1) + ". " + item.label; }).join("\n"),
        data.products.length ? "\nCOLOUR-MATCHED PRODUCTS\n" + data.products.map(function (item, index) { return (index + 1) + ". " + item.title; }).join("\n") : "",
        "",
        "ROOM PLAN",
        data.roomPlan.map(function (item) { return item.room + ": " + item.category + ". " + item.note; }).join("\n"),
        "",
        "DESIGNER READ",
        data.designerNote,
        "",
        "Confirm colour, product suitability, installation method and subfloor preparation in store."
      ];
      return lines.join("\n");
    }

    function copyBrief() {
      var text = briefText(latestResult);
      if (!text) return;
      var completed = false;
      function complete() {
        if (completed) return;
        completed = true;
        announce("Showroom brief copied.");
        var button = root.querySelector("[data-copy-brief]");
        if (button) {
          var original = button.textContent;
          button.textContent = "Brief copied";
          window.setTimeout(function () { button.textContent = original; }, 1800);
        }
      }
      if (fallbackCopy(text)) {
        complete();
        return;
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(complete).catch(function () {
          announce("Your browser blocked copying. Keep this result open for the showroom team.");
        });
      } else {
        announce("Your browser blocked copying. Keep this result open for the showroom team.");
      }
    }

    function fallbackCopy(text) {
      var textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.setAttribute("readonly", "");
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.select();
      var copied = false;
      try { copied = document.execCommand("copy"); } catch (error) { copied = false; }
      document.body.removeChild(textarea);
      return copied;
    }

    function handleExclusive(input) {
      if (!input || input.type !== "checkbox" || !input.name || !input.checked) return;
      var group = Array.prototype.slice.call(root.querySelectorAll('[name="' + input.name + '"]'));
      if (input.hasAttribute("data-exclusive")) {
        group.forEach(function (item) { if (item !== input) item.checked = false; });
      } else {
        group.forEach(function (item) { if (item.hasAttribute("data-exclusive")) item.checked = false; });
      }
    }

    function enforceMaximum(input) {
      if (!input || input.type !== "checkbox" || !input.checked) return;
      var screen = input.closest("[data-ffs-screen]");
      if (!screen || !screen.dataset.max) return;
      var max = parseInt(screen.dataset.max, 10);
      var checked = screen.querySelectorAll("input[type='checkbox']:checked").length;
      if (checked > max) {
        input.checked = false;
        announce("Choose up to " + max + " options.");
      }
    }

    function next() {
      var active = screens[step];
      if (!isScreenValid(active)) {
        announce(validationMessage(active));
        updateControls();
        return;
      }
      if (active && active.dataset.required === "rooms") buildLightRows();
      if (active && active.dataset.required === "colour") renderColourSuggestion();
      if (step < screens.length - 1) {
        step += 1;
        render();
        focusScreenHeading(screens[step]);
      }
    }

    function previous() {
      if (step <= 0) return;
      step -= 1;
      render();
      focusScreenHeading(screens[step]);
    }

    function setVideoSource(video) {
      if (!video || video.getAttribute("src") || !video.dataset.src) return;
      video.setAttribute("src", video.dataset.src);
      video.load();
    }

    function playVideo(video) {
      if (!video) return;
      var attempt = video.play();
      if (attempt && typeof attempt.catch === "function") attempt.catch(function () {});
    }

    function unloadVideo(video) {
      if (!video) return;
      video.pause();
      video.removeAttribute("src");
      video.load();
    }

    function introSeenThisSession() {
      try {
        return window.sessionStorage.getItem("nfFfsIntroSeen") === "1";
      } catch (error) {
        return false;
      }
    }

    function markIntroSeen() {
      try {
        window.sessionStorage.setItem("nfFfsIntroSeen", "1");
      } catch (error) {}
    }

    function clearIntroTimers() {
      if (entryTimer) window.clearTimeout(entryTimer);
      if (introCtaTimer) window.clearTimeout(introCtaTimer);
      entryTimer = null;
      introCtaTimer = null;
    }

    function revealIntroCta(focusCta) {
      clearIntroTimers();
      introClickReady = true;
      portal.classList.add("is-intro-cta");
      if (focusCta && introEnter) {
        window.setTimeout(function () { introEnter.focus({ preventScroll: true }); }, 30);
      }
    }

    function injectIntroVideo() {
      if (reduceMotion || !introVideo) return;
      setVideoSource(introVideo);
      introVideo.muted = true;
      playVideo(introVideo);
    }

    function stopIntroVideo() {
      unloadVideo(introVideo);
    }

    function applyParallax() {
      parallaxCurrent.lockX += (parallaxTarget.lockX - parallaxCurrent.lockX) * 0.12;
      parallaxCurrent.lockY += (parallaxTarget.lockY - parallaxCurrent.lockY) * 0.12;
      parallaxCurrent.videoX += (parallaxTarget.videoX - parallaxCurrent.videoX) * 0.12;
      parallaxCurrent.videoY += (parallaxTarget.videoY - parallaxCurrent.videoY) * 0.12;
      if (introLockup) {
        introLockup.style.setProperty("--ffs-lock-x", parallaxCurrent.lockX.toFixed(2) + "px");
        introLockup.style.setProperty("--ffs-lock-y", parallaxCurrent.lockY.toFixed(2) + "px");
      }
      if (introVideo) {
        introVideo.style.setProperty("--ffs-video-x", parallaxCurrent.videoX.toFixed(2) + "px");
        introVideo.style.setProperty("--ffs-video-y", parallaxCurrent.videoY.toFixed(2) + "px");
      }
      parallaxFrame = window.requestAnimationFrame(applyParallax);
    }

    function startIntroParallax() {
      if (reduceMotion || !entryStage || (window.matchMedia && window.matchMedia("(pointer: coarse)").matches)) return;
      if (!parallaxFrame) parallaxFrame = window.requestAnimationFrame(applyParallax);
    }

    function stopIntroParallax() {
      if (parallaxFrame) window.cancelAnimationFrame(parallaxFrame);
      parallaxFrame = null;
      parallaxTarget = { lockX: 0, lockY: 0, videoX: 0, videoY: 0 };
      parallaxCurrent = { lockX: 0, lockY: 0, videoX: 0, videoY: 0 };
      if (introLockup) {
        introLockup.style.removeProperty("--ffs-lock-x");
        introLockup.style.removeProperty("--ffs-lock-y");
      }
      if (introVideo) {
        introVideo.style.removeProperty("--ffs-video-x");
        introVideo.style.removeProperty("--ffs-video-y");
      }
    }

    function updateIntroParallax(event) {
      if (!introActive || reduceMotion || !event || event.pointerType === "touch") return;
      var x = (event.clientX / Math.max(1, window.innerWidth)) - 0.5;
      var y = (event.clientY / Math.max(1, window.innerHeight)) - 0.5;
      parallaxTarget.lockX = x * -16;
      parallaxTarget.lockY = y * -16;
      parallaxTarget.videoX = x * 8;
      parallaxTarget.videoY = y * 8;
    }

    function setOpenOrigin(event) {
      var x = window.innerWidth / 2;
      var y = window.innerHeight / 2;
      if (event && typeof event.clientX === "number" && typeof event.clientY === "number") {
        x = event.clientX;
        y = event.clientY;
      }
      portal.style.setProperty("--ffs-origin-x", x + "px");
      portal.style.setProperty("--ffs-origin-y", y + "px");
    }

    function triggerDaylightTransition() {
      portal.classList.add("is-daylight");
      window.setTimeout(function () { portal.classList.remove("is-daylight"); }, 540);
    }

    function proofButtonFor(video) {
      var card = video && video.closest("[data-ffs-proof-card]");
      return card ? card.querySelector("[data-ffs-proof-toggle]") : null;
    }

    function proofPlayButtonFor(video) {
      var card = video && video.closest("[data-ffs-proof-card]");
      return card ? card.querySelector("[data-ffs-proof-play]") : null;
    }

    function syncProofPlayback(video) {
      var button = proofPlayButtonFor(video);
      if (!button || !video) return;
      var playing = !video.paused && !video.ended;
      var label = button.dataset.proofLabel || "the proof video";
      button.setAttribute("aria-pressed", playing ? "true" : "false");
      button.setAttribute("aria-label", (playing ? "Pause " : "Play ") + label);
    }

    function syncProofButton(video) {
      var button = proofButtonFor(video);
      if (!button || !video) return;
      var soundOn = !video.muted;
      button.setAttribute("aria-pressed", soundOn ? "true" : "false");
      button.setAttribute("aria-label", soundOn ? "Turn sound off" : "Turn sound on");
    }

    function loadProofVideo(video, shouldPlay) {
      if (!video) return;
      setVideoSource(video);
      if (shouldPlay) playVideo(video);
    }

    function activateProofVideos() {
      if (!proofVideos.length || reduceMotion) return;
      if (!("IntersectionObserver" in window)) {
        proofVideos.forEach(function (video) { loadProofVideo(video, true); });
        return;
      }
      if (!proofObserver) {
        proofObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entryItem) {
            if (!entryItem.isIntersecting) return;
            var video = entryItem.target.querySelector("[data-ffs-proof-video]");
            loadProofVideo(video, true);
            proofObserver.unobserve(entryItem.target);
          });
        }, { root: null, rootMargin: "120px 0px", threshold: 0.2 });
      }
      proofCards.forEach(function (card) { proofObserver.observe(card); });
    }

    function pauseProofVideos(unload) {
      if (proofObserver && unload) {
        proofObserver.disconnect();
        proofObserver = null;
      }
      proofVideos.forEach(function (video) {
        video.pause();
        video.muted = true;
        syncProofButton(video);
        syncProofPlayback(video);
        if (unload) unloadVideo(video);
      });
    }

    function toggleProofPlayback(button) {
      var card = button && button.closest("[data-ffs-proof-card]");
      var video = card && card.querySelector("[data-ffs-proof-video]");
      if (!video) return;
      if (video.paused || video.ended) loadProofVideo(video, true);
      else video.pause();
      window.setTimeout(function () { syncProofPlayback(video); }, 0);
    }
    function toggleProofSound(button) {
      var card = button && button.closest("[data-ffs-proof-card]");
      var video = card && card.querySelector("[data-ffs-proof-video]");
      if (!video) return;
      loadProofVideo(video, true);
      proofVideos.forEach(function (item) {
        if (item !== video) {
          item.muted = true;
          syncProofButton(item);
        }
      });
      video.muted = !video.muted;
      syncProofButton(video);
      playVideo(video);
    }
    function resetStudio() {
      clearIntroTimers();
      introActive = false;
      introClickReady = false;
      portal.classList.remove("is-intro", "is-intro-cta", "is-intro-short");
      if (entry) entry.setAttribute("aria-hidden", "true");
      stopIntroParallax();
      stopIntroVideo();
      pauseProofVideos(true);
      clearThinkingTimers();
      Array.prototype.slice.call(form.querySelectorAll("input, select, textarea")).forEach(function (field) {
        if (field.type === "radio" || field.type === "checkbox") field.checked = field.defaultChecked;
        else field.value = field.defaultValue || "";
      });
      if (leadForm) leadForm.reset();
      customerName = "";
      colourTouched = false;
      thinkingStarted = false;
      if (lightHolder) lightHolder.innerHTML = "";
      productCards.forEach(function (card) { card.hidden = true; });
      latestResult = null;
      latestV3Brief = null;
      leadCaptured = false;
      leadSubmitting = false;
      leadViewTracked = false;
      leadAnalyticsContext = {};
      setLeadStatus("", false);
      setLeadState(false);
      step = 0;
      setNameHelp("Letters, spaces and hyphens only.", false);
      render();
      focusScreenHeading(screens[0]);
      announce("FloorFinder started again.");
    }

    function finishIntro() {
      clearIntroTimers();
      introActive = false;
      introClickReady = false;
      markIntroSeen();
      portal.classList.remove("is-intro", "is-intro-cta", "is-intro-short");
      if (entry) entry.setAttribute("aria-hidden", "true");
      stopIntroParallax();
      stopIntroVideo();
      window.setTimeout(function () {
        if (nameInput && step === 0) nameInput.focus({ preventScroll: true });
        else focusScreenHeading(screens[step]);
      }, 120);
      announce("FloorFinder Studio is open.");
    }

    function startIntro() {
      if (!entry) return;
      clearIntroTimers();
      introActive = true;
      introClickReady = reduceMotion;
      entry.setAttribute("aria-hidden", "false");
      portal.classList.remove("is-intro-cta", "is-intro-short");
      portal.classList.add("is-intro");
      if (introSeenThisSession()) {
        portal.classList.add("is-intro-short");
        introClickReady = true;
        entryTimer = window.setTimeout(function () { revealIntroCta(false); }, 1000);
      } else if (reduceMotion) {
        revealIntroCta(false);
      } else {
        introCtaTimer = window.setTimeout(function () { introClickReady = true; }, 2500);
        entryTimer = window.setTimeout(function () { revealIntroCta(false); }, 8000);
      }
      injectIntroVideo();
      startIntroParallax();
      window.setTimeout(function () {
        if (introSkip && introActive) introSkip.focus({ preventScroll: true });
      }, reduceMotion ? 80 : 1500);
    }

    function detectPreviewBar() {
      if (document.getElementById("PBarNextFrame") || document.getElementById("PBarNextFrameWrapper")) {
        document.body.classList.add("nf-ffs-preview-bar");
      }
    }

    function openStudio(event) {
      if (closeTimer) window.clearTimeout(closeTimer);
      setOpenOrigin(event);
      var hero = lightroom ? lightroom.querySelector("img") : null;
      if (hero && hero.src) (new Image()).src = hero.src;
      lastFocus = document.activeElement;
      portal.hidden = false;
      portal.setAttribute("aria-hidden", "false");
      document.body.classList.add("nf-ffs-lock");
      detectPreviewBar();
      window.requestAnimationFrame(function () {
        portal.classList.add("is-open");
        portal.focus({ preventScroll: true });
      });
      render();
      startIntro();
    }

    function closeStudio() {
      clearIntroTimers();
      introActive = false;
      introClickReady = false;
      portal.classList.remove("is-intro", "is-intro-cta", "is-intro-short");
      if (entry) entry.setAttribute("aria-hidden", "true");
      stopIntroParallax();
      stopIntroVideo();
      pauseProofVideos(true);
      portal.classList.remove("is-open");
      portal.setAttribute("aria-hidden", "true");
      document.body.classList.remove("nf-ffs-lock");
      closeTimer = window.setTimeout(function () { portal.hidden = true; }, 260);
      if (lastFocus && typeof lastFocus.focus === "function") lastFocus.focus({ preventScroll: true });
    }

    function trapFocus(event) {
      if (event.key !== "Tab" || !portal.classList.contains("is-open")) return;
      var focusRoot = introActive && entry ? entry : portal;
      var focusable = Array.prototype.slice.call(focusRoot.querySelectorAll("a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex='-1'])")).filter(function (element) {
        return element.offsetParent !== null;
      });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    root.addEventListener("click", function (event) {
      var opener = event.target.closest("[data-ffs-open]");
      var close = event.target.closest("[data-ffs-close]");
      var reset = event.target.closest("[data-ffs-reset]");
      var setAll = event.target.closest("[data-set-all-light]");
      var copy = event.target.closest("[data-copy-brief]");
      var nameStart = event.target.closest("[data-name-start]");
      var entryEnter = event.target.closest("[data-ffs-entry-enter]");
      var entrySkip = event.target.closest("[data-ffs-entry-skip]");
      var proofToggle = event.target.closest("[data-ffs-proof-toggle]");
      var proofPlay = event.target.closest("[data-ffs-proof-play]");
      var stageClick = introActive && entryStage && event.target.closest("[data-ffs-entry-stage]") && !entryEnter && !entrySkip;
      if (opener) {
        event.preventDefault();
        openStudio(event);
      }
      if (close) closeStudio();
      if (reset) resetStudio();
      if (copy) copyBrief();
      if (entrySkip) revealIntroCta(true);
      if (entryEnter) finishIntro();
      if (stageClick && introClickReady) revealIntroCta(false);
      if (proofPlay) toggleProofPlayback(proofPlay);
      if (proofToggle) toggleProofSound(proofToggle);
      if (nameStart && commitName()) {
        triggerDaylightTransition();
        next();
      }
      if (setAll && lightHolder) {
        var target = setAll.dataset.setAllLight;
        selectedRooms().forEach(function (room) {
          var input = lightHolder.querySelector('[data-room-light="' + room + '"][value="' + target + '"]');
          if (input) input.checked = true;
        });
        setLightroom(target);
        setSelectionClasses();
        updateControls();
        announce("All selected rooms set to " + (setAll.dataset.lightLabel || setAll.textContent.trim().toLowerCase()) + " light.");
      }
    });

    if (backButton) backButton.addEventListener("click", previous);
    if (nextButton) nextButton.addEventListener("click", next);
    function bindDirectControl(control, action) {
      if (!control) return;
      control.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        action();
      });
    }
    bindDirectControl(introEnter, finishIntro);
    bindDirectControl(introSkip, finishIntro);
    Array.prototype.forEach.call(root.querySelectorAll("[data-ffs-close]"), function (control) {
      bindDirectControl(control, closeStudio);
    });
    if (lightHolder) lightHolder.addEventListener("focusin", function (event) { if (event.target && event.target.dataset.roomLight) updateLightroom(event.target.dataset.roomLight); });

    if (leadForm) leadForm.addEventListener("submit", submitLead);
    form.addEventListener("input", function (event) {
      var input = event.target;
      if (!input || input.name !== "customer_name") return;
      setNameHelp("Letters, spaces and hyphens only.", false);
      updateControls();
    });
    form.addEventListener("change", function (event) {
      var input = event.target;
      if (!input || !input.matches("input")) return;
      handleExclusive(input);
      enforceMaximum(input);
      if (input.name === "rooms") {
        updateWetSpaces();
        buildLightRows();
      }
      if (input.name === "shade" || input.name === "colour_family") colourTouched = true;
      if (input.dataset.roomLight) updateLightroom(input.dataset.roomLight);
      if (screens[step] && screens[step].dataset.required === "colour") renderColourSuggestion();
      updateLookRail();
      setSelectionClasses();
      updateControls();
      if (input.type === "radio" && screens[step] && screens[step].hasAttribute("data-auto-advance")) {
        window.setTimeout(function () {
          if (screens[step] && screens[step].hasAttribute("data-auto-advance") && isScreenValid(screens[step])) next();
        }, reduceMotion ? 80 : 420);
      }
    });

    portal.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        event.preventDefault();
        closeStudio();
        return;
      }
      trapFocus(event);
    });

    productCards.forEach(function (card) {
      card.addEventListener("click", function () {
        if (latestResult && latestV3Brief) saveBrief(latestV3Brief, latestResult);
      });
    });

    proofVideos.forEach(function (video) {
      ["play", "pause", "ended"].forEach(function (eventName) {
        video.addEventListener(eventName, function () { syncProofPlayback(video); });
      });
      syncProofButton(video);
      syncProofPlayback(video);
    });
    if (introVideo) introVideo.addEventListener("ended", function () {
      if (introActive) revealIntroCta(false);
    });
    detectPreviewBar();
    window.setTimeout(detectPreviewBar, 800);
    if (entryStage) entryStage.addEventListener("pointermove", updateIntroParallax);
    if (progressTrack) progressTrack.setAttribute("aria-valuemax", String(questionCount));
    if (progressLabel) progressLabel.textContent = chapterLabel(screens[0]);
    updateNameTemplates();
    updateWetSpaces();
    render();


  }

  function initAll(scope) {
    Array.prototype.slice.call((scope || document).querySelectorAll(ROOT_SELECTOR)).forEach(initFloorFinder);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
      window.setTimeout(syncFloorFinderFromLocation, 180);
    });
  } else {
    initAll(document);
    window.setTimeout(syncFloorFinderFromLocation, 180);
  }

  document.addEventListener("shopify:section:load", function (event) { initAll(event.target); });

  function locationRequestsFloorFinder() {
    var params = new URLSearchParams(window.location.search);
    return params.get("floorfinder") === "1" || window.location.hash === "#floorfinder";
  }

  function syncFloorFinderFromLocation() {
    if (!locationRequestsFloorFinder()) return;
    if (document.querySelector(ROOT_SELECTOR + " [data-ffs-portal].is-open")) return;
    var opener = document.querySelector(ROOT_SELECTOR + " [data-ffs-open]");
    if (opener) opener.click();
  }

  if (!window.__nfFloorFinderLocationSync) {
    window.__nfFloorFinderLocationSync = true;
    window.addEventListener("hashchange", syncFloorFinderFromLocation);
    window.addEventListener("popstate", syncFloorFinderFromLocation);
  }

})();
